export const de = {
  // Navigation
  nav: {
    home: 'Home',
    services: 'Leistungen',
    about: 'Über uns',
    contact: 'Kontakt',
    implants: 'Implantate',
    veneers: 'Veneers',
    composite: 'Komposit-Aufbau',
    technology: 'Technologien',
    book: 'Online Termin buchen',
    emergency: 'Notdienst 24/7',
    privacyPolicy: 'Datenschutz',
    legalNotice: 'Impressum'
  },

  implants: {
    title: 'Implantate – Für mehr Lebensqualität',
    intro: 'Zahnimplantate sind die modernste und natürlichste Art, fehlende Zähne zu ersetzen. Sie bieten nicht nur eine perfekte Ästhetik, sondern geben Ihnen auch das Gefühl und die Sicherheit eigener Zähne zurück. In unserer Praxis in Palma setzen wir auf höchste Qualitätsstandards und modernste Verfahren.',
    benefitsTitle: "Vorteile von Implantaten",
    benefit1: "Natürliches Aussehen und Gefühl, vergleichbar mit eigenen Zähnen",
    benefit2: "Verbesserung der Kaufunktion und Sprechfähigkeit",
    benefit3: "Langlebige Lösung mit hoher Erfolgsrate",
    benefit4: "Erhalt der Kieferknochenstruktur",
    qualityTitle: "Höchste Qualität und Präzision",
    quality: "Wir verwenden ausschließlich hochwertige Materialien und modernste digitale Planungsverfahren. So garantieren wir Ihnen ein präzises und langlebiges Ergebnis, das perfekt zu Ihnen passt.",
    experienceTitle: "Angenehme Behandlungserfahrung",
    experience: "Dank minimalinvasiver Techniken und sanfter Betäubung ist die Behandlung bei uns besonders schonend. Unser Ziel ist es, dass Sie sich während des gesamten Prozesses wohl und sicher fühlen.",
    processTitle: "Der Weg zu Ihren neuen Implantaten",
    step1Title: "Beratung",
    step1: "Ausführliches Gespräch und individuelle Planung",
    step2Title: "Implantation",
    step2: "Schonender Eingriff unter örtlicher Betäubung",
    step3Title: "Einheilung",
    step3: "Verwachsung des Implantats mit dem Kieferknochen",
    step4Title: "Zahnersatz",
    step4: "Anfertigung und Einsetzen des individuellen Zahnersatzes",
    foreignImplants: {
      title: 'Implantat-Probleme — auch bei Fremdimplantaten',
      intro: 'Schmerzen am Implantat, eine gelockerte Krone oder entzündetes Zahnfleisch — und das Implantat wurde gar nicht bei uns gesetzt? Kein Problem: Wir behandeln auch Fremdimplantate, zum Beispiel aus der Türkei oder Ungarn.',
      body: 'Mit digitalem 3D-Röntgen (DVT) und computergestützter Diagnostik verschaffen wir uns ein genaues Bild von Implantat, Knochen und Zahnfleisch — auch ohne die Unterlagen der ursprünglichen Klinik. Gelöste Kronen befestigen wir neu, Entzündungen am Implantat behandeln wir gezielt, bevor der Knochen Schaden nimmt. Gerade im Urlaub gilt: Warten Sie nicht, bis Sie wieder zu Hause sind — je früher wir das Problem sehen, desto besser lässt sich Ihr Implantat schützen.',
      linkText: 'Zahnnotfall im Urlaub — unser Fahrplan für Touristen',
    }
  },
  veneers: {
    title: 'Veneers – Für Ihr strahlendes Lächeln',
    intro: 'Hauchdünne Keramikschalen, sogenannte Veneers, bieten eine elegante Lösung, um kleine Schönheitsfehler an den Frontzähnen dauerhaft zu korrigieren. Ob Verfärbungen, kleine Lücken oder leichte Fehlstellungen – wir verhelfen Ihnen zu einem harmonischen und natürlichen Lächeln.',
    imageAlt: "Veneers Behandlung bei SeaDent Mallorca",
    description: "Veneers sind individuell gefertigte Verblendschalen, die fest auf die Zahnoberfläche geklebt werden. Sie zeichnen sich durch ihre hohe Biokompatibilität und eine Ästhetik aus, die von natürlichen Zähnen kaum zu unterscheiden ist. In nur wenigen Sitzungen verwandeln wir Ihr Lächeln und schenken Ihnen neues Selbstbewusstsein."
  },
  composite: {
    title: 'Komposit-Zahnaufbau – Ihr neues Lächeln in einer Sitzung',
    intro: 'Direkter, additiver Aufbau Ihrer Zähne mit zahnfarbenem Composite in Freihand-Schichttechnik – ohne Beschleifen, ohne Labor, mit sichtbarem Ergebnis am selben Tag.',
    heroAlt: 'Vorher/Nachher-Vergleich Composite-Zahnaufbau bei SeaDent Mallorca',
    heroCaption: 'Vorher und nachher im direkten Vergleich. Composite-Aufbau an den oberen Frontzähnen rechts – die unbehandelte Seite links zum Vergleich. Form, Länge, Farbe und Helligkeit stimmen wir individuell mit Ihnen ab.',
    whatIsTitle: 'Was ist der direkte Composite-Aufbau?',
    whatIsBody: 'Der direkte Composite-Aufbau ist eine moderne, substanzschonende Methode der ästhetischen Zahnmedizin. Wir gestalten Form, Länge, Farbe und Stellung Ihrer Zähne neu – ohne Beschleifen, ohne Laborabdruck und ohne Provisorium. Ein hochwertiges, zahnfarbenes Composite wird in mehreren feinen Schichten direkt auf den Zahn appliziert, modelliert und mit Polymerisationslicht ausgehärtet.',
    whatIsResult: 'Das Ergebnis sehen Sie noch am selben Tag.',
    distinctionTitle: 'Wichtig: keine Veneers',
    distinctionBody: 'Bei klassischen Keramik-Veneers wird gesunde Zahnsubstanz beschliffen, um Platz für die Verblendschale zu schaffen. Unser Verfahren ist rein additiv: Wir fügen Material hinzu, ohne den natürlichen Zahn zu reduzieren – und damit vollständig reversibel.',
    indicationsTitle: 'Für wen ist die Behandlung geeignet?',
    indications: [
      { title: 'Ästhetische Frontzahn-Korrektur', body: 'Abgeplatzte Kanten, ungleichmäßige Längen, Asymmetrien und Formanomalien an den sichtbaren Frontzähnen.' },
      { title: 'Lückenschluss (Diastema)', body: 'Auch Lücken bis ca. 6–7 mm lassen sich ohne Kieferorthopädie schließen.' },
      { title: 'Wiederaufbau abradierter Zähne', body: 'Bei Bruxismus, Erosion oder altersbedingter Abrasion stellen wir die ursprüngliche Zahnform und -länge wieder her.' },
      { title: 'Additives Smile Makeover', body: 'Harmonische Neugestaltung mehrerer Frontzähne in einer einzigen Sitzung.' }
    ],
    whyTitle: 'Was unsere Methode besonders macht',
    whyBuildupAlt: 'Photoreal-Makro der Composite-Schichttechnik mit Lichthärtung',
    why: [
      { title: 'Ergebnis in einer Sitzung', body: '30–60 Minuten pro Zahn. Ein komplettes Frontzahn-Makeover (6–8 Zähne) erfolgt in einem Termin. Kein Labor, keine zweite Sitzung, kein Provisorium.' },
      { title: 'Freihand-Schichttechnik', body: 'Dentin- und Schmelzmassen werden in mehreren Lagen modelliert – wie bei einem natürlichen Zahn. Das Ergebnis hat echte Tiefenwirkung, Opaleszenz und Lichtbrechung.' },
      { title: 'Substanzschonend & reversibel', body: 'Ihre Zahnhartsubstanz bleibt vollständig erhalten. Alle weiteren Optionen bleiben offen.' }
    ],
    processTitle: 'Behandlungsablauf',
    processIllustrationAlt: 'Schematische Darstellung der Composite-Schichtung mit Polymerisationslampe',
    process: [
      { title: 'Beratung & Analyse', body: 'Klinische Untersuchung, Bissanalyse, Besprechung Ihrer Wünsche.' },
      { title: 'Farb- und Formbestimmung', body: 'Auswahl der Composite-Töne für Dentin- und Schmelzschichten.' },
      { title: 'Vorbereitung', body: 'Reinigung der Zahnoberfläche, Trockenlegung mit Kofferdam, adhäsive Konditionierung.' },
      { title: 'Schichtweiser Aufbau', body: 'Polychromatisches Layering mit Lichthärtung jeder Schicht.' },
      { title: 'Finieren & Hochglanzpolitur', body: 'Anatomische Mikrostruktur und natürlicher Glanz.' },
      { title: 'Kontrolle & Ergebnis', body: 'Sichtkontrolle, Bisskontrolle, Übergabe.' }
    ],
    aftercareTitle: 'Nach der Behandlung & Pflege',
    aftercare: [
      'Keine Wartezeit – Essen und Sprechen sofort möglich',
      'Erste 24–48 Stunden: stark färbende Lebensmittel (Kaffee, Rotwein, Tee, Curry, Beeren) meiden',
      'Pflege wie bei natürlichen Zähnen – zweimal täglich putzen, Interdentalreinigung, regelmäßige Prophylaxe',
      'Eiswürfel kauen oder Verpackungen mit den Frontzähnen öffnen vermeiden',
      'Bei Bruxismus: individuelle Aufbissschiene zum Schutz'
    ],
    longevityTitle: 'Haltbarkeit',
    longevityBody: 'Bei guter Mundhygiene und regelmäßiger Prophylaxe halten direkte Composite-Restaurationen bis zu 20 Jahre. Composite lässt sich nachpolieren, ergänzen und punktuell reparieren – ohne kompletten Austausch.',
    benefitsTitle: 'Vorteile auf einen Blick',
    benefits: [
      { label: '1 Sitzung', value: 'Sofort sichtbares Ergebnis' },
      { label: 'Kein Beschleifen', value: '100 % Zahnsubstanz erhalten' },
      { label: 'Schichtweiser Aufbau', value: 'Natürliche Optik wie ein echter Zahn' },
      { label: 'Reversibel', value: 'Alle weiteren Optionen bleiben offen' },
      { label: 'Reparierbar', value: 'Kleine Korrekturen ohne Komplettaustausch' },
      { label: 'Faires Preisniveau', value: 'Deutlich günstiger als laborgefertigte Versorgungen' }
    ],
    faqTitle: 'Häufige Fragen',
    faq: [
      { q: 'Ist die Behandlung schmerzhaft?', a: 'Nein. Da kein Bohren erfolgt, ist in den meisten Fällen keine Betäubung erforderlich.' },
      { q: 'Wie lange dauert ein Termin?', a: '30–60 Minuten pro Zahn. Komplette Smile Makeovers planen wir an einem Tag.' },
      { q: 'Sieht man, dass es nicht der eigene Zahn ist?', a: 'Bei korrekt ausgeführter Schichttechnik mit Dentin- und Schmelzmassen ist das Composite optisch nicht vom natürlichen Zahn zu unterscheiden.' },
      { q: 'Wie pflege ich die aufgebauten Zähne?', a: 'Wie Ihre natürlichen Zähne. Wichtig sind professionelle Zahnreinigungen alle 6 Monate.' },
      { q: 'Verfärbt sich das Material?', a: 'Modernes Composite ist farbstabil. Leichte Oberflächenverfärbungen lassen sich in der Regel durch eine Politur entfernen.' },
      { q: 'Wie lange hält das Ergebnis?', a: 'Bei guter Pflege bis zu 20 Jahre. Reparaturen sind jederzeit möglich, ohne den gesamten Aufbau auszutauschen.' },
      { q: 'Was passiert, wenn ein Stück abbricht?', a: 'Wir reparieren punktuell, ohne den gesamten Aufbau zu erneuern.' },
      { q: 'Ist die Behandlung für mich geeignet?', a: 'Das klären wir in einem persönlichen Beratungstermin. Bei sehr ausgeprägtem Verschleiß oder Bissproblemen sprechen wir offen über die geeignete Methode.' },
      { q: 'Was kostet das?', a: 'Abhängig von Anzahl und Komplexität der Zähne. Sie erhalten einen schriftlichen Kostenvoranschlag vor Beginn.' }
    ],
    ctaTitle: 'Bereit für Ihr neues Lächeln?',
    ctaBody: 'Vereinbaren Sie ein persönliches Beratungsgespräch. Wir hören zu, untersuchen und sagen Ihnen ehrlich, was möglich ist.',
    ctaButton: 'Beratungstermin online buchen',
    ctaCall: 'Oder anrufen'
  },

  // Header
  header: {
    logoText: "SeaDent Mallorca",
    phone: "603 31 96 48",
    whatsapp: "WhatsApp",
    languageToggle: "ES",
    reviews: {
      rating: "5.0",
      count: "470+ Rezensionen",
      google: "Google Bewertungen"
    }
  },

  // Common
  common: {
    loading: 'Laden...',
    error: 'Ein Fehler ist aufgetreten',
    save: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    clear: 'Löschen',
    refresh: 'Aktualisieren',
    search: 'Suchen',
    filter: 'Filter',
    actions: 'Aktionen',
    status: 'Status',
    date: 'Datum',
    time: 'Zeit',
    email: 'E-Mail',
    phone: 'Telefon',
    notes: 'Notizen',
    created: 'Erstellt',
    updated: 'Aktualisiert',
    name: 'Name',
    description: 'Beschreibung',
    duration: 'Dauer',
    color: 'Farbe',
    yes: 'Ja',
    no: 'Nein',
    confirm: 'Bestätigen',
    minutes: 'Minuten',
    bookNow: 'Jetzt buchen'
  },

  // Cookie Consent
  cookieConsent: {
    title: "Cookie-Einstellungen",
    description: "Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Durch die Nutzung unserer Website erklären Sie sich mit unserer Cookie-Richtlinie einverstanden.",
    acceptAll: "Alle akzeptieren",
    acceptNecessary: "Nur notwendige",
    settings: "Einstellungen",
    save: "Einstellungen speichern",
    close: "Schließen",
    privacyPolicy: "Datenschutzrichtlinie",
    categories: {
      necessary: {
        title: "Notwendig",
        description: "Diese Cookies sind für das Funktionieren der Website erforderlich und können nicht deaktiviert werden."
      },
      preferences: {
        title: "Präferenzen",
        description: "Diese Cookies ermöglichen es der Website, sich an von Ihnen vorgenommene Auswahlmöglichkeiten zu erinnern."
      },
      statistics: {
        title: "Statistiken",
        description: "Diese Cookies helfen uns zu verstehen, wie Besucher mit der Website interagieren."
      },
      marketing: {
        title: "Marketing",
        description: "Diese Cookies werden verwendet, um Besuchern relevante Anzeigen und Marketingkampagnen anzuzeigen."
      }
    }
  },

  // Admin
  admin: {
    title: 'Admin Dashboard',
    login: 'Anmelden',
    logout: 'Abmelden',
    dashboard: 'Dashboard',
    username: 'Benutzername',
    password: 'Passwort',
    loginButton: 'Anmelden',
    loginError: 'Ungültige Anmeldedaten',
    loginRequired: 'Bitte melden Sie sich an, um auf das Admin-Panel zuzugreifen',
    welcome: 'Willkommen im Admin Dashboard',
    overview: 'Übersicht',
    quickActions: 'Schnellaktionen',
    recentActivity: 'Letzte Aktivitäten',
    systemStatus: 'Systemstatus',
    googleCalendarStatus: 'Google Calendar',
    databaseStatus: 'Datenbank',
    connected: 'Verbunden',
    disconnected: 'Getrennt',
    healthy: 'Gesund',
    error: 'Fehler'
  },

  // Calendar
  calendar: {
    title: 'Terminkalender',
    next: 'Weiter',
    previous: 'Zurück',
    today: 'Heute',
    month: 'Monat',
    week: 'Woche',
    day: 'Tag',
    noEvents: 'Keine Termine in diesem Zeitraum',
    filterBy: 'Filtern nach',
    allProviders: 'Alle Behandler',
    allProcedures: 'Alle Behandlungen',
    allOperatories: 'Alle Behandlungsräume',
    refresh: 'Kalender aktualisieren',
    googleCalendarSync: 'Synchronisiert...'
  },

  // Appointments
  appointments: {
    title: 'Termine',
    create: 'Termin erstellen',
    edit: 'Termin bearbeiten',
    update: 'Termin aktualisieren',
    view: 'Termin anzeigen',
    delete: 'Termin löschen',
    cancel: 'Termin stornieren',
    confirm: 'Bestätigen',
    completed: 'Als abgeschlossen markieren',
    noShow: 'Nicht erschienen',
    patient: 'Patient',
    provider: 'Behandler',
    procedure: 'Behandlung',
    operatory: 'Behandlungsraum',
    date: 'Datum',
    time: 'Zeit',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    status: 'Status',
    notes: 'Notizen',
    language: 'Sprache',
    total: 'Gesamttermine',
    today: 'Heute',
    thisWeek: 'Diese Woche',
    thisMonth: 'Dieser Monat',
    upcoming: 'Kommende',
    recent: 'Letzte',
    search: 'Termine suchen...',
    filters: 'Filter',
    exportToExcel: 'Nach Excel exportieren',
    importFromExcel: 'Aus Excel importieren',
    bulkActions: 'Massenaktionen',
    selectAll: 'Alle auswählen',
    selectedCount: 'Ausgewählt: {count}',
    conflictDetected: 'Terminkonflikt erkannt',
    googleCalendarEvent: 'Google Calendar Ereignis',
    syncWithGoogleCalendar: 'Mit Google Calendar synchronisieren',
    createGoogleCalendarEvent: 'Google Calendar Ereignis erstellen',
    updateGoogleCalendarEvent: 'Google Calendar Ereignis aktualisieren',
    deleteGoogleCalendarEvent: 'Google Calendar Ereignis löschen'
  },

  // Providers
  providers: {
    title: 'Behandler',
    add: 'Behandler hinzufügen',
    edit: 'Behandler bearbeiten',
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefon',
    specialization: 'Spezialisierung',
    schedule: 'Zeitplan',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    workingHours: 'Arbeitszeiten',
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    dayOff: 'Frei',
    saveSchedule: 'Zeitplan speichern',
    scheduleUpdated: 'Zeitplan erfolgreich aktualisiert'
  },

  // Procedures
  procedures: {
    title: 'Behandlungen',
    add: 'Behandlung hinzufügen',
    edit: 'Behandlung bearbeiten',
    name: 'Name',
    description: 'Beschreibung',
    duration: 'Dauer (Minuten)',
    price: 'Preis',
    category: 'Kategorie',
    color: 'Farbe',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    categories: {
      consultation: 'Beratung',
      cleaning: 'Reinigung',
      filling: 'Füllung',
      crown: 'Krone',
      implant: 'Implantat',
      veneer: 'Veneer',
      extraction: 'Extraktion',
      root_canal: 'Wurzelbehandlung',
      orthodontics: 'Kieferorthopädie',
      surgery: 'Chirurgie',
      other: 'Andere'
    }
  },

  // Operatories
  operatories: {
    title: 'Behandlungsräume',
    add: 'Behandlungsraum hinzufügen',
    edit: 'Behandlungsraum bearbeiten',
    name: 'Name',
    description: 'Beschreibung',
    equipment: 'Ausstattung',
    capacity: 'Kapazität',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    location: 'Standort',
    floor: 'Etage',
    room: 'Raum',
    specialEquipment: 'Spezialausrüstung'
  },

  // Status
  status: {
    scheduled: 'Geplant',
    confirmed: 'Bestätigt',
    completed: 'Abgeschlossen',
    cancelled: 'Storniert',
    no_show: 'Nicht erschienen',
    pending: 'Ausstehend',
    approved: 'Genehmigt',
    rejected: 'Abgelehnt',
    active: 'Aktiv',
    inactive: 'Inaktiv'
  },

  // Messages
  messages: {
    appointmentCreated: 'Termin erfolgreich erstellt',
    appointmentUpdated: 'Termin erfolgreich aktualisiert',
    appointmentDeleted: 'Termin erfolgreich gelöscht',
    appointmentCancelled: 'Termin erfolgreich storniert',
    providerCreated: 'Behandler erfolgreich erstellt',
    providerUpdated: 'Behandler erfolgreich aktualisiert',
    providerDeleted: 'Behandler erfolgreich gelöscht',
    procedureCreated: 'Behandlung erfolgreich erstellt',
    procedureUpdated: 'Behandlung erfolgreich aktualisiert',
    procedureDeleted: 'Behandlung erfolgreich gelöscht',
    operatoryCreated: 'Behandlungsraum erfolgreich erstellt',
    operatoryUpdated: 'Behandlungsraum erfolgreich aktualisiert',
    operatoryDeleted: 'Behandlungsraum erfolgreich gelöscht',
    saveSuccess: 'Änderungen erfolgreich gespeichert',
    deleteSuccess: 'Element erfolgreich gelöscht',
    confirmDelete: 'Möchten Sie dieses Element wirklich löschen?',
    confirmCancel: 'Möchten Sie diesen Termin wirklich stornieren?',
    conflictDetected: 'Ein Terminkonflikt wurde erkannt',
    googleCalendarSynced: 'Google Calendar erfolgreich synchronisiert',
    googleCalendarError: 'Fehler beim Synchronisieren mit Google Calendar',
    googleCalendarSync: 'Synchronisiert mit Google Calendar...',
    exportSuccess: 'Daten erfolgreich exportiert',
    importSuccess: 'Daten erfolgreich importiert',
    noDataToExport: 'Keine Daten zum Exportieren vorhanden',
    invalidFileFormat: 'Ungültiges Dateiformat',
    networkError: 'Netzwerkfehler. Bitte versuchen Sie es erneut.',
    sessionExpired: 'Sitzung abgelaufen. Bitte melden Sie sich erneut an.',
    accessDenied: 'Zugriff verweigert',
    formValidationError: 'Bitte korrigieren Sie die Fehler im Formular',
    requiredField: 'Dieses Feld ist erforderlich',
    invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    invalidPhone: 'Bitte geben Sie eine gültige Telefonnummer ein',
    invalidDate: 'Bitte geben Sie ein gültiges Datum ein',
    invalidTime: 'Bitte geben Sie eine gültige Zeit ein',
    startTimeAfterEndTime: 'Startzeit muss vor Endzeit liegen',
    duplicateEntry: 'Dieser Eintrag existiert bereits',
    noResults: 'Keine Ergebnisse gefunden',
    loadingData: 'Daten werden geladen...',
    noDataAvailable: 'Keine Daten verfügbar'
  },

  // Reports
  reports: {
    title: 'Berichte',
    appointmentReport: 'Terminbericht',
    providerReport: 'Behandlerbericht',
    procedureReport: 'Behandlungsbericht',
    revenueReport: 'Umsatzbericht',
    cancellationReport: 'Stornierungsbericht',
    noShowReport: 'Nicht-Erscheinen-Bericht',
    dateRange: 'Datumsbereich',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    generateReport: 'Bericht erstellen',
    exportReport: 'Bericht exportieren',
    printReport: 'Bericht drucken',
    reportGenerated: 'Bericht erfolgreich erstellt',
    noDataForReport: 'Keine Daten für die ausgewählten Kriterien verfügbar',
    totalAppointments: 'Gesamttermine',
    completedAppointments: 'Abgeschlossene Termine',
    cancelledAppointments: 'Stornierte Termine',
    noShowAppointments: 'Nicht-Erscheinen-Termine',
    totalRevenue: 'Gesamtumsatz',
    averageRevenue: 'Durchschnittsumsatz',
    topProcedures: 'Top-Behandlungen',
    topProviders: 'Top-Behandler',
    appointmentsByStatus: 'Termine nach Status',
    appointmentsByProvider: 'Termine nach Behandler',
    appointmentsByProcedure: 'Termine nach Behandlung',
    dailyAppointments: 'Tägliche Termine',
    weeklyAppointments: 'Wöchentliche Termine',
    monthlyAppointments: 'Monatliche Termine'
  },

  // Settings
  settings: {
    title: 'Einstellungen',
    general: 'Allgemein',
    notifications: 'Benachrichtigungen',
    googleCalendar: 'Google Calendar',
    backup: 'Backup',
    users: 'Benutzer',
    clinicName: 'Klinikname',
    clinicAddress: 'Klinikadresse',
    clinicPhone: 'Kliniktelefon',
    clinicEmail: 'Klinik-E-Mail',
    timezone: 'Zeitzone',
    language: 'Sprache',
    dateFormat: 'Datumsformat',
    timeFormat: 'Zeitformat',
    currency: 'Währung',
    emailNotifications: 'E-Mail-Benachrichtigungen',
    smsNotifications: 'SMS-Benachrichtigungen',
    reminderTime: 'Erinnerungszeit',
    calendarId: 'Kalender-ID',
    apiKey: 'API-Schlüssel',
    clientId: 'Client-ID',
    clientSecret: 'Client-Secret',
    testConnection: 'Verbindung testen',
    connectionSuccessful: 'Verbindung erfolgreich',
    connectionFailed: 'Verbindung fehlgeschlagen',
    backupDatabase: 'Datenbank sichern',
    restoreDatabase: 'Datenbank wiederherstellen',
    backupCreated: 'Backup erfolgreich erstellt',
    backupRestored: 'Backup erfolgreich wiederhergestellt',
    addUser: 'Benutzer hinzufügen',
    editUser: 'Benutzer bearbeiten',
    role: 'Rolle',
    permissions: 'Berechtigungen',
    admin: 'Admin',
    user: 'Benutzer',
    viewer: 'Betrachter'
  },

  // Booking form (original content)
  booking: {
    title: 'Termin vereinbaren',
    subtitle: 'Vereinbaren Sie einen Termin mit unserem erfahrenen Team',
    form: {
      name: 'Vollständiger Name',
      email: 'E-Mail-Adresse',
      phone: 'Telefonnummer',
      service: 'Behandlung',
      date: 'Wunschtermin',
      time: 'Wunschzeit',
      message: 'Zusätzliche Anmerkungen',
      language: 'Bevorzugte Sprache',
      submit: 'Termin buchen',
      submitting: 'Wird gesendet...',
      success: 'Ihre Terminanfrage wurde erfolgreich übermittelt!',
      error: 'Bei der Übermittlung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
      required: 'Dieses Feld ist erforderlich'
    },
    services: {
      consultation: 'Beratung',
      cleaning: 'Reinigung',
      filling: 'Füllung',
      crown: 'Krone',
      implant: 'Implantat',
      veneer: 'Veneer',
      extraction: 'Extraktion',
      root_canal: 'Wurzelbehandlung',
      orthodontics: 'Kieferorthopädie',
      surgery: 'Chirurgie',
      other: 'Andere'
    },
    languages: {
      english: 'Englisch',
      german: 'Deutsch',
      spanish: 'Spanisch',
      russian: 'Russisch'
    },
    times: {
      morning: '9:00',
      midMorning: '10:00',
      lateMorning: '11:00',
      noon: '12:00',
      afternoon: '14:00',
      midAfternoon: '15:00',
      lateAfternoon: '16:00',
      evening: '17:00'
    }
  },

  // Hero Section
  hero: {
    title: 'SeaDent Mallorca: Ihr Lächeln zählt.',
    subtitle: 'Moderne Zahnmedizin mit Einfühlungsvermögen.',
    description: 'Erleben Sie erstklassige Zahnmedizin im Herzen von Mallorca. Unsere moderne Klinik verbindet deutsche Präzision mit mediterraner Wärme.',
    cta: 'Online Termin buchen',
    emergency: 'Notfall anrufen',
    makeover: {
      title: 'Smile Makeover mit Composite',
      subtitle: 'Direkter Aufbau in Freihand-Schichttechnik – minimalinvasiv und natürlich schön.',
      cta: 'Mehr erfahren'
    },
    rotation: {
      on: 'Drehung: an',
      off: 'Drehung: aus'
    },
    scrollMore: 'Mehr erfahren',
    banner: {
      title: "Individueller Komfort - den Sie spüren",
      subtitle: "(und warum unsere Patienten so gerne wiederkommen)",
      buttons: {
        cosmetic: "Ästhetische Zahnmedizin",
        pediatric: "Kinderzahnheilkunde",
        general: "Allgemeine Zahnmedizin",
        whitening: "Zahnaufhellung"
      }
    }
  },

  // Booking Wizard
  bookingWizard: {
    steps: {
      treatment: "Welche Art von Termin?",
      insurance: "Wie möchten Sie abrechnen?",
      dateTime: "Wunschtermin & Zeit wählen"
    },
    treatments: {
      cleaning: "Professionelle Zahnreinigung + Untersuchung (Zahnarzt)",
      returningCleaning: "Wiederkehrende Patienten-Zahnreinigung (Zahnprophylaxe-Assistent) + Untersuchung (Zahnarzt)",
      consultation: "Allgemeine Zahnärztliche Beratung (Zahnarzt)",
      cosmetic: "Ästhetische Zahnärztliche Beratung (Zahnarzt)",
      secondOpinion: "Zweitmeinung Zahnärztliche Beratung (Zahnarzt)",
      emergency: "Zahnärztlicher Notfalltermin (Röntgenaufnahmen + Zahnarztuntersuchung)",
      whitening: "Professionelle Zahnaufhellungsbehandlung",
      botox: "Botox-Beratung (Zahnarzt)",
      tmj: "Kiefergelenk (Kieferschmerz) Beratung (Zahnarzt)",
      pediatric: "Kinderzahnheilkunde (Zahnmedizin für Kinder)"
    },
    insurance: {
      search: "Versicherung eingeben",
      privatePay: "Privatleistung",
      privatePayDesc: "Selbstzahler · keine Versicherung erforderlich",
      withInsurance: "Über meine Versicherung",
      withInsuranceDesc: "Versicherungsname angeben"
    },
    navigation: {
      back: "Zurück",
      next: "Weiter",
      close: "Schließen"
    },
    getDirections: "Wegbeschreibung",
    instantBookingBy: "Sofortige Buchung durch"
  },

  // Services Section
  services: {
    title: 'Unsere Leistungen',
    subtitle: 'Umfassende Zahnmedizin',
    implants: {
      title: 'Zahnimplantate',
      description: 'Dauerhafte Lösung für fehlende Zähne mit Titanimplantaten'
    },
    veneers: {
      title: 'Veneers',
      description: 'Verwandeln Sie Ihr Lächeln mit individuellen Porzellanveneers'
    },
    cleaning: {
      title: 'Professionelle Reinigung',
      description: 'Gründliche Reinigung und Vorsorge für optimale Mundgesundheit'
    },
    crown: {
      title: 'Kronen & Brücken',
      description: 'Wiederherstellung beschädigter Zähne mit hochwertigen Kronen und Brücken'
    },
    orthodontics: {
      title: 'Kieferorthopädie',
      description: 'Begradigen Sie Ihre Zähne mit modernen kieferorthopädischen Behandlungen'
    },
    surgery: {
      title: 'Oralchirurgie',
      description: 'Expertenhafte chirurgische Eingriffe in unseren modernen Operationssälen'
    }
  },

  // Treatments Section
  treatments: {
    title: "Behandlungen: Ihr Lächeln in besten Händen",
    intro: "Unsere Behandlungen bei SeaDent Mallorca umfassen das gesamte Spektrum der modernen Zahnmedizin – von der Vorsorge bis zur ästhetischen Perfektion. Mit fortschrittlicher Technologie und einfühlsamer Betreuung sorgen wir für Ihre Mundgesundheit und ein strahlendes Lächeln.",
    cta: "Jetzt Termin vereinbaren",
    categories: [
      {
        title: "Vorsorge und Prophylaxe",
        description: "Regelmäßige Kontrollen und präventive Maßnahmen für eine langfristige Mundgesundheit. Wir setzen auf individuelle Beratung und moderne Diagnostik.",
        treatments: [
          {
            title: "Kontrolle und Beratung",
            description: "Ausführliche Untersuchungen und persönliche Empfehlungen für gesunde Zähne."
          },
          {
            title: "Professionelle Zahnreinigung",
            description: "Gründliche Entfernung von Zahnbelag für ein sauberes und frisches Gefühl."
          },
          {
            title: "Füllungen",
            description: "Hochwertige Füllungen, die Ihre Zähne ästhetisch und funktional wiederherstellen."
          },
          {
            title: "Kinderprophylaxe",
            description: "Kindgerechte Vorsorge, um die Zähne Ihrer Kleinen spielerisch zu schützen."
          }
        ]
      },
      {
        title: "Schmerztherapie",
        description: "Schmerzfreie Behandlungen durch sanfte Techniken und modernste Technologien. Ihr Wohlbefinden steht bei jeder Sitzung im Mittelpunkt.",
        treatments: [
          {
            title: "Schmerzbehandlung",
            description: "Schnelle und effektive Linderung von Zahnschmerzen, individuell auf Sie abgestimmt."
          },
          {
            title: "Zahnentfernung",
            description: "Schonende Entfernung von Zähnen, wenn keine andere Lösung möglich ist."
          },
          {
            title: "Wurzelbehandlung",
            description: "Präzise Endodontie zur Rettung entzündeter Zähne und Schmerzlinderung."
          },
          {
            title: "Kiefergelenksprobleme",
            description: "Gezielte Therapie bei Kiefergelenksproblemen (TMJ) für bessere Lebensqualität."
          }
        ]
      },
      {
        title: "Parodontitis",
        description: "Professionelle Behandlung von Zahnfleischerkrankungen für eine stabile Mundgesundheit. Frühzeitige Maßnahmen verhindern langfristige Schäden.",
        treatments: [
          {
            title: "Behandlungsmaßnahmen",
            description: "Professionelle Reinigung und Therapien zur effektiven Bekämpfung von Zahnfleischentzündungen."
          }
        ]
      },
      {
        title: "Für ein perfektes Lächeln (Ästhetik)",
        description: "Ästhetische Lösungen für ein selbstbewusstes Lächeln, ganz nach Ihren Wünschen. Unsere Methoden sind schonend und effektiv.",
        treatments: [
          {
            title: "Komposit-Zahnaufbau",
            description: "Direkter ästhetischer Aufbau in einer Sitzung – ohne Beschleifen, mit Freihand-Schichttechnik."
          },
          {
            title: "Invisalign",
            description: "Transparente Aligner für eine diskrete und komfortable Zahnkorrektur."
          },
          {
            title: "Zahnaufhellung",
            description: "Schonende Aufhellung Ihrer Zähne für ein strahlendes, weißes Lächeln."
          },
          {
            title: "Knirschschienen",
            description: "Maßgeschneiderte Schienen zur Vorbeugung von Zähneknirschen und Schutz Ihres Gebisses."
          },
          {
            title: "Veneers",
            description: "Hauchdünne Keramikschalen für ein perfektes und natürliches Aussehen Ihrer Zähne."
          },
          {
            title: "Kronen und Brücken",
            description: "Hochwertiger Zahnersatz für Funktion und Ästhetik bei beschädigten Zähnen."
          }
        ]
      },
      {
        title: "Implantate",
        description: "Modernste Implantattechnologie für einen natürlichen und dauerhaften Zahnersatz. Unsere Implantate bieten Ihnen Komfort und Sicherheit.",
        treatments: [
          {
            title: "Einzelimplantate",
            description: "Ersatz einzelner Zähne mit hochwertigen Implantaten für ein natürliches Gefühl."
          },
          {
            title: "Mehrfachimplantate",
            description: "Umfassende Implantatlösungen für größere Zahnlücken oder komplette Zahnreihen."
          },
          {
            title: "Sofortimplantate",
            description: "Implantate mit sofortiger Belastung für eine schnelle Wiederherstellung Ihrer Kaufunktion."
          }
        ]
      }
    ]
  },

  // Benefits Section
  benefits: {
    title: 'Ihre Vorteile: Exzellenz, Komfort und ein Lächeln, das strahlt.',
    items: [
      {
        title: 'Erfahrung und Kompetenz',
        description: 'Qualifizierte Zahnärzte mit kontinuierlicher Fortbildung.'
      },
      {
        title: 'Modernste Technologie',
        description: 'Präzise Behandlungen mit digitalem Röntgen und innovativen Geräten.'
      },
      {
        title: 'Patientenzentrierte Betreuung',
        description: 'Einfühlsame Behandlung, wie Sie sie von einem Freund erwarten würden.'
      },
      {
        title: 'Mediterrane Atmosphäre',
        description: 'Eine entspannte Umgebung inspiriert von der Schönheit Mallorcas.'
      },
      {
        title: 'Mehrsprachiger Service',
        description: 'Behandlung auf Deutsch, Englisch und Spanisch.'
      },
      {
        title: 'Zentrale Lage',
        description: 'Leicht erreichbar im Herzen von Palma de Mallorca.'
      }
    ]
  },

  // Approach Section
  approach: {
    title: 'Zahnmedizin neu gedacht: Ihr Wohlbefinden, unser Versprechen.',
    text: 'Bei SeaDent möchten wir, dass Ihr Zahnarztbesuch etwas Besonderes wird. Unsere Mission ist es, Ihnen nicht nur medizinisch exzellente Behandlungen, sondern auch eine Atmosphäre zu bieten, in der Sie sich entspannt und verstanden fühlen. Das bedeutet für uns:',
    points: [
      'Wir hören zu: Ihre Wünsche und Bedürfnisse stehen im Mittelpunkt unserer Betreuung. Wir nehmen uns Zeit für eine individuelle Beratung.',
      'Entspannung und schmerzfreie Behandlungen: Mit modernsten Methoden und dem Fokus auf Ihr Wohlbefinden machen wir Behandlungen so komfortabel wie möglich.',
      'Transparenz schafft Vertrauen: Wir erklären jeden Schritt Ihrer Behandlung klar und verständlich, damit Sie sich sicher fühlen.'
    ]
  },

  // Team Section
  team: {
    title: 'Unser Team',
    subtitle: 'Experten für Ihr Lächeln',
    description: 'Unser erfahrenes Team aus Zahnärzten und Dentalhygienikern widmet sich der bestmöglichen Versorgung.',
    cta: 'Lernen Sie unser Team kennen'
  },

  // Experience Section
  experience: {
    title: 'Ihre Wohlfühlmomente bei SeaDent Mallorca.',
    text: 'Bei SeaDent geht es um mehr als nur Zahnmedizin – wir möchten, dass Ihr Besuch zu einem Moment der Entspannung wird. Unsere Praxis verbindet modernste Behandlungen mit einer Atmosphäre, die von der Ruhe und Schönheit Mallorcas inspiriert ist.',
    points: [
      'Einladende Atmosphäre mit mediterranen Farben und natürlichem Licht.',
      'Freundliches und einfühlsames Team, das Sie herzlich willkommen heißt.',
      'Kurze Wartezeiten dank effizienter Praxisorganisation.',
      'Komfortable Wartebereiche mit WLAN, Getränken und Pflanzen.',
      'Entspannende Details wie beruhigende Musik während der Behandlung.'
    ]
  },

  // Social Proof Section
  socialProof: {
    title: "Was unsere Patienten sagen",
    reviews: [
      {
        text: "Fachlich top, menschlich großartig, hier fühlt man sich wirklich gut aufgehoben ❤️. Ein riesiges Dankeschön an den Zahnarzt und das ganze Team. So stelle ich mir eine moderne, herzliche Praxis vor 🦷🤗.",
        author: "Marcel"
      },
      {
        text: "So einen engagierten, herzlichen und ehrlichen Zahnarzt habe ich noch nie erlebt. Er nimmt sich immer viel Zeit – sogar außerhalb der normalen Praxiszeiten – und ist jederzeit für seine Patienten da. Die Behandlungen sind professionell und werden mit viel Empathie durchgeführt. Auch nach dem Termin kümmert er sich um die Nachsorge und möchte wissen, wie es einem geht – das ist alles andere als selbstverständlich. Ein absolut toller Zahnarzt, dem man voll und ganz vertrauen kann. Absolute Empfehlung!",
        author: "Stefanie"
      },
      {
        text: "Top Zahnarzt!!! Ich bekam natürlich genau im Urlaub extreme Zahnschmerzen nach einer Füllung die ein paar Wochen her war. Warten bis ich zu Hause in Deutschland zur Zahnarztin gehen kann, war nicht möglich. Ich bekam bei Jan D. Heiringhoff sofort einen Termin. Er ist super sympathisch, hört zu, stellt Fragen und hat die nötige Wurzelkanalbehandlung super gemacht. Meine Zahnärztin in Deutschland meinte danach, dass er die Wurzelkanalbehandlung super gemacht hat. Ich hatte während der Behandlung und danach keine Probleme oder sogar Schmerzen. Ich kann ihn bestens weiter empfehlen!",
        author: "Hendrik"
      },
      {
        text: "Ich war wirklich sehr froh, nach einer schlaflosen Nacht, wegen akuten Zahnschmerzen, eine schnelle und unkomplizierte Antwort zu bekommen. Die Behandlung, erfolgte auch prompt und professionell. Schön, dass es noch Ärzte gibt, die auch am Samstag arbeiten und dabei noch sehr freundlich und kompetent sind. Vielen Dank.",
        author: "T."
      },
      {
        text: "Sofortige (!) und professionelle Notfallbehandlung. Transparent und auf Augenhöhe. Vielen Dank an das Team, ich habe mich sehr gut aufgehoben gefühlt. NACHTRAG (einige Monate später): Zurück in der Praxis und diesmal Bleaching in Anspruch genommen. Alles professionell und freundlich. Einfach eine empfehlenswerte Praxis! 👍",
        author: "Hubert"
      },
      {
        text: "Ich wurde super freundlich empfangen und behandelt. Dr. Heiringhoff hat sich viel Zeit genommen und alles ausführlich erklärt. Er hat auf meinen Wunsch hin 2 Röntgenaufnahmen meiner neuen Krone gemacht. Ich hatte Angst, eine Wurzelentzündung zu haben. Dem war nicht so und ich konnte beruhigt gehen. Ich kann Dr. Heiringhoff unbedingt weiterempfehlen. Danke, für die schnelle Hilfe an einem Sonntag ☺️.",
        author: "Elke"
      },
      {
        text: "Meine Zähne sahen vorher ehrlich gesagt richtig crack aus – so, dass ich auf Fotos lieber ernst geguckt hab, als zu lächeln. Aber dann kam Jan! Der Typ hat aus meinem Gebiss ein Lächeln gemacht, das sich sehen lassen kann. Super entspannt, null Zahnarzt-Angst und echt mit Liebe zum Detail. Jetzt grins ich wieder, als wär ich frisch aus der Zahnpasta-Werbung. Danke, Jan – du bist mein Zahnheld!",
        author: "Patrick"
      },
      {
        text: "Vielen Dank für die schnelle Hilfe. Hatte während des Urlaubs einen Zahnnotfall. Bekam sofort einen Termin, wo ich super beraten und behandelt wurde. Empfehlung von Herzen.",
        author: "Simone"
      }
    ]
  },

  // Technologies Section
  technologies: {
    title: 'Moderne Technologie',
    subtitle: 'Hochmoderne Ausstattung',
    intro: 'Bei SeaDent legen wir Wert auf eine individuelle, angenehme und schmerzfreie Zahnmedizin durch den Einsatz modernster Technik.',
    sections: [
      {
        title: 'Digitale Zahnheilkunde',
        description: 'Digitale Abformungen und 3D-Visualisierung für eine präzise Diagnostik und Behandlungsplanung.',
        benefits: [
          'Schnelle und bequeme digitale Zahnerfassung.',
          'Deutlich höherer Komfort als bei Abdrücken.',
          'Möglichkeit zur Visualisierung Ihrer Behandlungsergebnisse.',
          'Trägt zu einer schnelleren und angenehmeren Behandlung bei.'
        ]
      },
      {
        title: 'Dentallaser: Das heilende Licht',
        description: 'Ein Dentallaser ist ein vielseitiges Instrument, das viele herkömmliche Werkzeuge ersetzt und die Heilung unterstützt. Er arbeitet genau, effizient und sicher. Nutzen des Dentallasers für Sie:',
        benefits: [
          'Unterstützt die Heilung von Zahnfleisch, Knochen und mehr.',
          'Ermöglicht kleinere chirurgische Eingriffe.',
          'Hilft bei der Sterilisation von Wurzelkanälen.',
          'Wird zur Blutstillung bei Eingriffen eingesetzt.',
          'Effektive Behandlung von Aphten und Herpes.',
          'Unterstützt die Parodontitisbehandlung.',
          'Hilft bei der Desensibilisierung empfindlicher Zahnhälse.'
        ]
      },
      {
        title: 'Implantattechnologie',
        description: 'Fortschrittliche Implantatsysteme für optimale Einheilung und langfristigen Erfolg.',
        benefits: [
          'Hochwertige Materialien (Titan/Keramik)',
          'Computergestützte Planung für maximale Sicherheit',
          'Langlebige und ästhetische Ergebnisse'
        ]
      },
      {
        title: 'Dentalmikroskop',
        description: 'Mikroskopische Präzision für endodontische Behandlungen und feinste chirurgische Eingriffe.',
        benefits: [
          'Maximale Detailgenauigkeit',
          'Höhere Erfolgsraten bei Wurzelbehandlungen',
          'Minimalinvasives Vorgehen'
        ]
      }
    ],
    conclusion: 'Durch die Kombination dieser modernen Technologien mit unserem Fokus auf Vertrauen und Transparenz erleben Sie bei SeaDent eine Zahnmedizin, die professionell, angenehm und persönlich ist.'
  },

  cta: {
    title: 'Erleben Sie Zahnmedizin, die Sie in den Mittelpunkt stellt.',
    text: 'Bereit für eine Zahnarztpraxis, die Professionalität mit mediterranem Komfort verbindet? Vereinbaren Sie Ihren Termin bei SeaDent Mallorca und entdecken Sie eine neue Art der Zahnmedizin – wir freuen uns, Sie in Palma willkommen zu heißen!',
    bookButton: 'Online Termin buchen',
    callButton: 'Rufen Sie uns an',
    visitInfo: 'Besuchen Sie uns: Avenida de Jaime III № 3, Palma, Mallorca.'
  },

  // Footer
  footer: {
    legal: {
      title: 'Impressum',
      privacy: 'Datenschutz',
      cookieSettings: 'Cookie-Einstellungen'
    },
    links: {
      title: 'Navigation',
      home: 'Startseite',
      contact: 'Kontakt',
      book: 'Termin buchen'
    },
    contact: {
      title: 'Kontaktinformationen',
      practice: 'SeaDent Mallorca',
      address: 'Avenida de Jaime III, № 3',
      city: '07012 Palma de Mallorca',
      owner: 'Inhaber: Jan D. Heiringhoff',
      phone: '603 31 96 48',
      whatsapp: 'WhatsApp: 603 31 96 48',
      email: 'info@seadent.es',
      hours: 'Mo-Fr: 09:00 - 18:00'
    },
    copyright: '© {year} SeaDent Mallorca. Alle Rechte vorbehalten.'
  },

  // Contact
  contact: {
    title: 'Kontaktieren Sie uns',
    subtitle: 'Nehmen Sie Kontakt auf',
    contactInfo: 'Kontaktinformationen',
    address: 'Adresse',
    phone: 'Telefon',
    email: 'E-Mail',
    emergencyTitle: 'Notfallservice',
    emergencyText: 'Für Notfälle steht Ihnen ein 24/7-Service zur Verfügung',
    appointment: 'Terminvereinbarung',
    findUsTitle: 'Wo Sie uns finden',
    directionsButton: 'Anfahrt anzeigen',
    transportTitle: 'Anfahrt',
    publicTransport: 'Öffentliche Verkehrsmittel',
    publicTransportInfo: 'Wir befinden uns im Herzen von Palma, in der Nähe der wichtigsten Bushaltestellen an der Jaime III.',
    byCar: 'Mit dem Auto',
    byCarInfo: 'Mehrere öffentliche Parkplätze befinden sich in der Nähe, darunter das Parking Vía Roma und El Corte Inglés.',
    form: {
      name: 'Name',
      email: 'E-Mail',
      subject: 'Betreff',
      message: 'Nachricht',
      send: 'Nachricht senden',
      success: 'Nachricht erfolgreich gesendet!',
      error: 'Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut.'
    }
  },

  // Emergency
  emergency: {
    title: 'Zahnnotfall',
    subtitle: 'Wir sind 24/7 für Sie da',
    intro: 'Wenn Sie einen Zahnnotfall haben, kontaktieren Sie uns sofort. Unser Notfallteam ist rund um die Uhr verfügbar, um Ihnen die benötigte Behandlung zu bieten.',
    call: 'Jetzt anrufen',
    whatsapp: 'WhatsApp',
    cta: 'Rufen Sie 603 31 96 48 an',
    details: [
      {
        title: 'Verfügbarkeit',
        description: 'Unser Notfallteam ist 24 Stunden am Tag, 365 Tage im Jahr erreichbar, auch an Wochenenden und Feiertagen.'
      },
      {
        title: 'Kontakt',
        description: 'Rufen Sie uns unter 603 31 96 48 an, um sofortige Hilfe zu erhalten. Wir akzeptieren auch WhatsApp-Nachrichten.'
      },
      {
        title: 'Häufige Notfälle',
        description: 'Wir behandeln starke Zahnschmerzen, abgebrochene Zähne, ausgeschlagene Zähne und andere Zahntraumata.'
      },
      {
        title: 'Service',
        description: 'Wir bieten sofortige Schmerzlinderung und langfristige Lösungen unter Einsatz modernster Zahntechnik.'
      }
    ],
    common: {
      title: 'Häufige Zahnnotfälle',
      toothache: 'Starke Zahnschmerzen',
      broken: 'Gebrochener oder angeschlagener Zahn',
      knocked: 'Ausgeschlagener Zahn',
      bleeding: 'Zahnfleischbluten',
      swelling: 'Gesichtsschwellung',
      lost: 'Verlorene Füllung oder Krone',
      // === Notfall-Offensive 2026: gemeinsame Bausteine aller Notfall-Seiten (Hub + Spokes) ===
      breadcrumbHome: 'Notdienst',
      callNow: 'Jetzt anrufen: 603 31 96 48',
      whatsappCta: 'Per WhatsApp: Foto senden',
      bookOnline: 'Online Termin buchen',
      backToHub: 'Alle Notfälle: unser zahnärztlicher Notdienst in Palma',
      locationLine: 'Sie finden uns zentral in Palma: Avenida de Jaime III, 3 · 07012 Palma de Mallorca — Parkplätze in den Parkhäusern Vía Roma und El Corte Inglés.',
      calloutReviews: '5.0 ★ bei Google — 470+ Rezensionen',
      authorBox: {
        label: 'Medizinische Qualitätssicherung',
        name: 'Jan David Heiringhoff',
        credential: 'Col·legiat Nº 07001232 — Col·legi Oficial de Dentistes de Balears',
        reviewedLabel: 'Medizinisch geprüft von',
        reviewedDate: 'Stand: Juli 2026',
      },
      midCta: {
        title: 'Jetzt anrufen — zentral an der Avenida Jaime III',
        body: 'Ein Anruf genügt: Wir hören zu, geben Ihnen eine erste Einschätzung und melden uns in unter 30 Minuten zurück, falls wir gerade behandeln. Parken können Sie in den Parkhäusern Vía Roma und El Corte Inglés, nur wenige Gehminuten entfernt.',
        button: 'Anrufen: 603 31 96 48',
      },
    },
    instructions: {
      title: 'Was zu tun ist',
      toothache: 'Spülen Sie mit warmem Salzwasser und nehmen Sie rezeptfreie Schmerzmittel.',
      broken: 'Bewahren Sie alle Teile auf und spülen Sie den Mund mit warmem Wasser.',
      knocked: 'Fassen Sie den Zahn an der Krone, nicht an der Wurzel an. Halten Sie ihn feucht.',
      bleeding: 'Üben Sie sanften Druck mit einem sauberen Tuch oder Gaze aus.',
      swelling: 'Legen Sie eine kalte Kompresse auf die Außenseite Ihrer Wange.',
      lost: 'Halten Sie den Bereich sauber und vermeiden Sie das Kauen auf dieser Seite.'
    },
    // === Designer-Redesign v2 (redesign emergency/DESIGN.md) ===
    // Neue strukturierte Keys für das überarbeitete Page-Layout. Die
    // bestehenden Keys oben bleiben unangetastet, damit andere Komponenten
    // (Footer-Snippets, Booking-Form-Texte) weiter funktionieren.
    v2: {
      heroBadge: '24/7 JETZT VERFÜGBAR',
      heroAccent: 'Wir sind für Sie da.',
      heroIntro: 'Bei starken Schmerzen, Zahntrauma oder abgebrochenen Zähnen versorgt Sie unser Notfall-Team sofort, einfühlsam und 365 Tage im Jahr.',
      callBtn: 'ANRUFEN: 603 31 96 48',
      whatsappBtn: 'WHATSAPP',
      stats: {
        availability: 'Erreichbarkeit',
        daysAYear: 'Tage im Jahr',
        responseTime: 'Reaktionszeit',
        rating: 'Patienten-Bewertung',
      },
      common: {
        title: 'Häufige Zahnnotfälle',
        intro: 'Schnelle Versorgung ist für Ihre langfristige Zahngesundheit entscheidend. Wir behandeln alle Notfälle mit klinischer Exzellenz.',
        eyebrow: 'Expertenversorgung in Palma',
        cards: [
          {
            title: 'Starke Zahnschmerzen',
            description: 'Pulsierende oder stechende Schmerzen deuten oft auf Infektionen oder Nervenschäden hin — die sofort behandelt werden müssen.',
            checks: ['Sofortdiagnostik', 'Wurzelbehandlung'],
          },
          {
            title: 'Zahntrauma',
            description: 'Gebrochene, abgesplitterte oder ausgeschlagene Zähne nach Unfällen erfordern schnelles Handeln, um den Zahn zu retten.',
            checks: ['Notfall-Rekonstruktion', 'Replantation'],
          },
          {
            title: 'Abszess & Infektion',
            description: 'Schwellungen und Fieber sind Zeichen schwerer Zahninfektionen — sie benötigen Antibiotika oder einen chirurgischen Eingriff.',
            checks: ['Infektions-Drainage', 'Schmerzbehandlung'],
          },
        ],
      },
      process: {
        title: 'Was tun im Notfall?',
        steps: [
          {
            title: 'Sofort anrufen',
            description: 'Rufen Sie uns unter 603 31 96 48 an und beschreiben Sie kurz Ihre Symptome — so können wir Ihre Ankunft vorbereiten.',
          },
          {
            title: 'Erste Maßnahmen',
            description: 'Bei Schmerzen von außen kühlen. Bei Zahnbruch das Fragment in Milch oder Speichel aufbewahren.',
          },
          {
            title: 'Zur Praxis kommen',
            description: 'Avenida de Jaime III № 3, Palma — zentrale Lage für schnellen Zugang.',
          },
        ],
      },
      location: {
        eyebrow: 'Unsere Praxis',
        title: 'SeaDent Mallorca',
        intro: 'Im Herzen von Palma — mediterrane Atmosphäre kombiniert mit modernster Medizintechnik.',
        addressLine1: 'Avenida de Jaime III № 3',
        addressLine2: '07012 Palma de Mallorca',
        hoursLabel: 'Mo – Fr: 09:00 – 18:00',
        emergencyHours: 'Notfall-Telefon: 24/7 erreichbar',
        directions: 'Anfahrt anzeigen',
      },
      finalCta: {
        title: 'Wir sind für Sie da.',
        intro: 'Zahnschmerzen sind belastend. Unser einfühlsames Team ist bereit, schnelle Hilfe und Fachkompetenz zu bieten — damit Ihr Lächeln in besten Händen ist.',
        button: 'NOTRUF: 603 31 96 48',
      },
    },

    // === Notfall-Offensive 2026: Hub-Upgrade (SEO_NOTFALL_PLAN.md §4.1) ===
    triage: {
      title: 'Wann sofort anrufen? Ihre Notfall-Ampel',
      intro: 'Nicht jeder Zahnnotfall ist gleich dringend. Im Zweifel gilt immer: Rufen Sie an — wir schätzen die Lage gemeinsam mit Ihnen ein.',
      levels: [
        {
          tone: 'now',
          label: 'Sofort anrufen — jetzt zählen Minuten',
          items: [
            'Zahn komplett ausgeschlagen — die besten Chancen bestehen innerhalb von 60 Minuten',
            'Starke Schwellung an Wange, Auge oder Hals, dazu Fieber oder Schluckbeschwerden',
            'Blutung im Mund, die sich nicht stillen lässt',
            'Heftiger, pochender Schmerz, der Sie nicht zur Ruhe kommen lässt',
          ],
        },
        {
          tone: 'today',
          label: 'Noch heute behandeln lassen',
          items: [
            'Zahn abgebrochen — mit scharfer Kante oder Schmerzempfindlichkeit',
            'Zahn nach Sturz oder Stoß gelockert oder verschoben',
            'Füllung oder Krone verloren, der Zahn reagiert empfindlich',
            'Zahnschmerzen, die trotz Kühlen nicht nachlassen',
          ],
        },
        {
          tone: 'week',
          label: 'Zeitnah in dieser Woche abklären',
          items: [
            'Kleine abgeplatzte Ecke ohne Schmerzen',
            'Leichte Empfindlichkeit bei Kaltem oder Süßem',
            'Zahnfleischbluten beim Putzen, ohne Schwellung oder Schmerz',
          ],
        },
      ],
    },
    hubCards: {
      title: 'Die häufigsten Zahnnotfälle — und was jetzt zu tun ist',
      cards: [
        {
          icon: 'sick',
          title: 'Akute Zahnschmerzen',
          teaser: 'Pochender oder stechender Schmerz, der einfach nicht aufhört? Dahinter steckt fast immer eine Ursache, die wir noch am selben Tag behandeln können.',
          linkText: 'Akute Zahnschmerzen — was hilft jetzt?',
          routeKey: 'emergency-toothache',
        },
        {
          icon: 'dentistry',
          title: 'Zahn abgebrochen oder ausgeschlagen',
          teaser: 'Ein Stück Zahn liegt in der Hand? In den meisten Fällen können wir kleben — der Aufbau gelingt oft in einer einzigen Sitzung.',
          linkText: 'Zahn abgebrochen — was tun?',
          routeKey: 'emergency-broken-tooth',
        },
        {
          icon: 'emergency',
          title: 'Abszess & dicke Backe',
          teaser: 'Eine geschwollene Wange ist ein Warnsignal, das Sie nicht aussitzen sollten — ein Abszess geht nicht von selbst weg.',
          linkText: 'Zahnabszess — warum Sie heute handeln sollten',
          routeKey: 'emergency-abscess',
        },
        {
          icon: 'flight',
          title: 'Zahnnotfall im Urlaub',
          teaser: 'Notfall statt Strandtag? Wir behandeln Sie so, dass Ihr Urlaub weitergehen kann — auf Deutsch, Englisch oder Spanisch.',
          linkText: 'Zahnnotfall im Urlaub — Ihr Fahrplan',
          routeKey: 'emergency-tourists',
        },
        {
          icon: 'child_care',
          title: 'Zahnunfall beim Kind',
          teaser: 'Sturz am Pool oder vom Rad? Bleiben Sie ruhig — entscheidend ist, ob ein Milchzahn oder ein bleibender Zahn betroffen ist.',
          linkText: 'Zahnunfall beim Kind — Milchzahn oder bleibender Zahn?',
          routeKey: 'emergency-broken-tooth',
        },
      ],
    },
    weekend: {
      title: 'Auch am Wochenende, an Feiertagen und nachts erreichbar',
      paragraphs: [
        'Zahnschmerzen halten sich nicht an Öffnungszeiten. Deshalb trennen wir klar zwischen Praxis und Notfall-Telefon: Unsere Praxis ist Montag bis Freitag von 09:00 bis 18:00 Uhr geöffnet — unser Notfall-Telefon 603 31 96 48 erreichen Sie dagegen rund um die Uhr, auch am Wochenende, an Feiertagen und nachts.',
        'So läuft es ab: Sie rufen an oder schreiben per WhatsApp, wir melden uns in unter 30 Minuten zurück, geben eine erste Einschätzung und vereinbaren bei Bedarf einen Notfalltermin nach telefonischer Absprache — auch außerhalb der regulären Praxiszeiten.',
        'Der Unterschied zum anonymen Bereitschaftsdienst: Bei uns werden Sie mit der vollen Ausstattung der Praxis behandelt — Dentalmikroskop, Dentallaser und digitales 3D-Röntgen (DVT) — statt mit einer Übergangslösung.',
      ],
    },
    hubSolve: {
      title: 'So lösen wir das bei SeaDent',
      items: [
        {
          problem: 'Zahn abgebrochen oder abgeplatzt',
          solution: 'Composite-Direktaufbau in einer einzigen Sitzung: Wir bauen den Zahn in Freihand-Schichttechnik wieder auf — ohne Beschleifen, reversibel und später punktuell reparierbar. Kurz gesagt: Wir können kleben.',
          linkText: 'Composite-Aufbau in einer Sitzung',
          routeKey: 'composite',
        },
        {
          problem: 'Akute Zahnschmerzen, entzündeter Zahnnerv',
          solution: 'Diagnose mit digitalem 3D-Röntgen (DVT), Wurzelbehandlung unter dem Dentalmikroskop, Dentallaser zur Keimreduktion — wir versuchen immer zuerst, Ihren Zahn zu erhalten.',
          linkText: 'Mikroskop, Laser & 3D-Röntgen: unsere Technologien',
          routeKey: 'technologies',
        },
        {
          problem: 'Probleme mit dem Implantat',
          solution: 'Computergestützte Diagnostik — auch, wenn Ihr Implantat woanders gesetzt wurde. Wir befestigen gelöste Kronen neu und behandeln Entzündungen am Implantat.',
          linkText: 'Implantate bei SeaDent',
          routeKey: 'implants',
        },
      ],
    },
    hubFaq: {
      title: 'Häufige Fragen zum zahnärztlichen Notdienst',
      items: [
        {
          q: 'Was kostet ein Notfalltermin?',
          a: 'Das hängt von Befund und Behandlung ab. Fest steht: Sie erhalten vor jeder Behandlung einen schriftlichen Kostenvoranschlag, können mit Karte zahlen und bekommen eine detaillierte Rechnung für Ihre Versicherung. Ohne Ihr Einverständnis wird nichts gemacht.',
        },
        {
          q: 'Sind Sie auch sonntags erreichbar?',
          a: 'Ja — unser Notfall-Telefon 603 31 96 48 ist rund um die Uhr besetzt, an jedem Tag der Woche. Notfalltermine außerhalb der Praxiszeiten (Mo–Fr 09:00–18:00 Uhr) vereinbaren wir nach telefonischer Absprache.',
        },
        {
          q: 'Meine Krone ist abgebrochen — was soll ich tun?',
          a: 'Krone aufbewahren und nicht selbst festkleben — Haushaltskleber schädigt Zahn und Krone. Oft können wir sie wieder befestigen; falls nicht, reparieren wir mit Composite oder fertigen digital einen Ersatz an.',
        },
        {
          q: 'Mein Implantat schmerzt — behandeln Sie auch Implantate aus der Türkei oder Ungarn?',
          a: 'Ja. Wir behandeln Implantat-Probleme unabhängig davon, wo das Implantat gesetzt wurde — mit computergestützter Diagnostik, Wiederbefestigung gelöster Kronen und gezieltem Entzündungsmanagement.',
        },
        {
          q: 'Was passiert bei einer Notfall-Wurzelbehandlung?',
          a: 'Unter örtlicher Betäubung entfernen wir das entzündete Nervengewebe — unter dem Dentalmikroskop, mit Dentallaser zur Keimreduktion. Der Schmerz stoppt in der Regel noch in derselben Sitzung, der Zahn bleibt in vielen Fällen erhalten.',
        },
        {
          q: 'Ist Zahnfleischbluten ein Notfall?',
          a: 'Meist nicht — dahinter steckt in der Regel eine Zahnfleischentzündung, die zeitnah, aber nicht sofort behandelt werden muss. Kommen Schwellung, Eiter, pochender Schmerz oder Fieber hinzu, kann ein Abszess dahinterstecken: Dann rufen Sie uns noch heute an.',
        },
        {
          q: 'Welche Sprachen sprechen Sie?',
          a: 'Wir betreuen Sie auf Deutsch, Englisch und Spanisch — vom ersten Anruf über die Behandlung bis zum Befundbericht für Ihren Hauszahnarzt.',
        },
      ],
    },
    homeTeaser: {
      title: 'Zahnnotfall auf Mallorca?',
      body: 'Starke Zahnschmerzen, ein abgebrochener Zahn, eine dicke Backe: Unser Notfall-Telefon ist rund um die Uhr erreichbar — und in den meisten Fällen können wir noch am selben Tag helfen. Zentral in Palma, auf Deutsch, Englisch und Spanisch.',
      linkText: 'Zum zahnärztlichen Notdienst in Palma',
    },
    footerTitle: 'Notfall',

    // === Spoke: Zahn abgebrochen / ausgeschlagen (§4.2) ===
    brokenTooth: {
      breadcrumb: 'Zahn abgebrochen',
      h1: 'Zahn abgebrochen auf Mallorca? Wir können kleben — Soforthilfe in Palma',
      heroIntro: 'Das tut weh und macht Angst — atmen Sie durch: Für fast jeden Zahnunfall gibt es eine gute Lösung, oft noch am selben Tag. In den meisten Fällen lässt sich ein abgebrochener Zahn direkt wieder aufbauen, ganz ohne Krone. Rufen Sie uns an — wir sagen Ihnen sofort, was jetzt zu tun ist.',
      heroNote: 'Tipp: Schicken Sie uns per WhatsApp ein Foto vom Zahn — so können wir die Lage einschätzen, noch bevor Sie bei uns sind.',
      warnbox: {
        title: 'Zahn komplett ausgeschlagen? Jetzt zählen Minuten.',
        body: 'Ein replantierter Zahn hat die besten Chancen innerhalb von 60 Minuten. Lagern Sie den Zahn feucht — am besten in Milch — und rufen Sie uns an, WÄHREND Sie zu uns kommen. Wir bereiten alles vor, damit es bei Ihrer Ankunft sofort losgeht.',
      },
      sections: [
        {
          icon: 'healing',
          title: 'Sofortmaßnahmen: die ersten 4 Schritte',
          intro: 'Was Sie in den ersten Minuten tun, entscheidet mit darüber, wie gut sich Ihr Zahn retten lässt. Vier Schritte genügen:',
          items: [
            {
              title: '1. Zahn oder Bruchstück suchen und feucht lagern',
              body: 'Legen Sie den Zahn oder das Fragment in kalte Milch oder bewahren Sie es notfalls im eigenen Speichel auf. Ideal ist eine Zahnrettungsbox aus der Apotheke: Sie enthält eine spezielle Nährlösung, in der die empfindlichen Zellen der Wurzelhaut bis zu 24 Stunden überleben — wenn eine Apotheke in der Nähe ist, lohnt sich der kurze Umweg. Auf keinen Fall trocken transportieren: nicht im Taschentuch, nicht in der Hosentasche.',
            },
            {
              title: '2. Nur an der Krone anfassen',
              body: 'Greifen Sie den Zahn ausschließlich am weißen, sichtbaren Teil — nie an der Wurzel. Die Wurzeloberfläche ist von einer hauchdünnen, lebenden Zellschicht überzogen, und genau diese Zellen braucht der Zahn, um wieder anzuwachsen. Jede Berührung schadet ihnen.',
            },
            {
              title: '3. Nicht säubern',
              body: 'Auch wenn der Zahn schmutzig ist: nicht abwischen, nicht abrubbeln, nicht desinfizieren. Höchstens ganz kurz und ohne Druck mit kalter Milch abspülen. Die gründliche Reinigung übernehmen wir — schonend und unter kontrollierten Bedingungen.',
            },
            {
              title: '4. Von außen kühlen',
              body: 'Legen Sie eine kalte Kompresse oder ein in ein Tuch gewickeltes Kühlelement auf die Wange. Das lindert den Schmerz und bremst die Schwellung. Bei Blutung im Mund: mit einem sauberen Tuch oder einer Kompresse sanften Druck ausüben.',
            },
          ],
        },
        {
          icon: 'checklist',
          title: 'Abgebrochen, ausgeschlagen oder gelockert? Der Unterschied entscheidet',
          intro: 'Drei Situationen, drei verschiedene Wege — diese Übersicht zeigt Ihnen auf einen Blick, was Ihr Fall bedeutet:',
          table: {
            headers: ['Situation', 'Woran Sie es erkennen', 'Was Sie tun sollten', 'Dringlichkeit'],
            rows: [
              [
                'Zahn abgebrochen',
                'Ein Stück fehlt, die Kante fühlt sich scharf an, der Zahn reagiert evtl. auf Kalt und Warm',
                'Fragment in Milch aufbewahren, von außen kühlen, noch heute anrufen',
                'Hoch — am selben Tag behandeln lassen',
              ],
              [
                'Zahn ausgeschlagen (Avulsion)',
                'Der komplette Zahn samt Wurzel ist heraus',
                'Nur an der Krone anfassen, sofort in Milch oder Zahnrettungsbox legen, anrufen und direkt losfahren',
                'Maximal — das 60-Minuten-Fenster zählt',
              ],
              [
                'Zahn gelockert oder verschoben',
                'Der Zahn wackelt, steht schief oder fühlt sich beim Zubeißen „zu hoch" an',
                'Nicht daran wackeln, weiche Kost, nicht auf dem Zahn kauen, zeitnah vorstellen',
                'Hoch — heute oder morgen früh',
              ],
            ],
          },
        },
        {
          icon: 'crown',
          title: 'Krone oder Veneer abgebrochen?',
          intro: 'Auch das ist ein Fall für uns — und meist schneller gelöst, als Sie denken.',
          items: [
            {
              title: 'Krone abgebrochen oder herausgefallen',
              body: 'Bewahren Sie die Krone auf und versuchen Sie bitte nicht, sie mit Haushaltskleber zu befestigen — das schädigt Zahn und Krone und erschwert jede weitere Versorgung. Ist die Krone intakt, können wir sie oft einfach wieder einsetzen. Falls nicht, bauen wir den Zahn mit Composite auf oder nehmen eine digitale Abformung mit dem Intraoralscanner für den passgenauen Ersatz — ohne klebrige Abdrucklöffel.',
            },
            {
              title: 'Veneer abgeplatzt oder gelöst',
              body: 'Ein gelöstes Veneer lässt sich häufig wiederbefestigen. Ist es gebrochen, reparieren wir die Stelle mit Composite in Ihrer Zahnfarbe — punktuell und ohne dass gleich ein komplett neues Veneer nötig wird. Sie gehen an keinem Tag mit sichtbarer Lücke nach Hause.',
            },
          ],
        },
      ],
      solve: {
        title: 'So lösen wir das bei SeaDent: Wir können kleben',
        intro: 'Vielerorts endet ein abgebrochener Zahn im Terminkarussell: Provisorium, Abdruck, Labor, zweite Sitzung. Bei uns nicht. Unser Weg ist der direkte Composite-Aufbau — und der ist in einer einzigen Sitzung abgeschlossen.',
        points: [
          {
            title: 'Composite-Direktaufbau in einer Sitzung',
            body: 'Wir bauen den abgebrochenen Zahn in Freihand-Schichttechnik direkt im Mund wieder auf — Schicht für Schicht, in Ihrer Zahnfarbe, mit natürlicher Tiefenwirkung. Ohne Beschleifen, ohne Labor, ohne Provisorium. Sie kommen mit einem abgebrochenen Zahn und gehen mit einem vollständigen Lächeln.',
          },
          {
            title: 'Reversibel und punktuell reparierbar',
            body: 'Ihre gesunde Zahnsubstanz bleibt vollständig erhalten. Und was passiert, wenn später wieder ein Stück abbricht? Wir reparieren punktuell — Sie brauchen keine neue Krone und keinen kompletten Neuaufbau.',
          },
          {
            title: 'Bei ausgeschlagenem Zahn: Replantation und Schienung',
            body: 'Einen komplett ausgeschlagenen Zahn setzen wir zurück und stabilisieren ihn mit einer Schiene an den Nachbarzähnen. Unter dem Dentalmikroskop kontrollieren wir dabei jedes Detail — je schneller Sie bei uns sind, desto besser die Prognose.',
          },
        ],
        links: [
          { text: 'Composite-Aufbau: Ihr neues Lächeln in einer Sitzung', routeKey: 'composite' },
          { text: 'Mikroskop, Laser & 3D-Röntgen: unsere Technologien', routeKey: 'technologies' },
        ],
      },
      faq: {
        title: 'Häufige Fragen zum abgebrochenen Zahn',
        items: [
          {
            q: 'Wie lange lässt sich ein abgebrochener Zahn noch retten?',
            a: 'Ein abgebrochenes Stück lässt sich auch nach Stunden noch verwenden, wenn es feucht gelagert wurde — und selbst ohne Fragment bauen wir den Zahn mit Composite vollständig wieder auf. Kritisch ist nur der komplett ausgeschlagene Zahn: Hier zählt das 60-Minuten-Fenster. Rufen Sie in jedem Fall sofort an.',
          },
          {
            q: 'Was kostet der Wiederaufbau?',
            a: 'Das hängt von Größe und Lage des Defekts ab. Sie erhalten vor der Behandlung einen schriftlichen Kostenvoranschlag — ohne versteckte Positionen. Ein direkter Composite-Aufbau ist in aller Regel deutlich günstiger als eine laborgefertigte Krone.',
          },
          {
            q: 'Mein Kind hat sich einen Zahn ausgeschlagen — gilt das Gleiche?',
            a: 'Nicht ganz. Ein Milchzahn wird nie wieder eingesetzt, weil die Replantation den darunterliegenden Keim des bleibenden Zahns schädigen kann. Bewahren Sie den Zahn trotzdem auf, kühlen Sie die Lippe und kommen Sie mit Ihrem Kind zu uns — wir kontrollieren, ob der bleibende Zahn etwas abbekommen hat. Bei einem bleibenden Zahn, meist ab dem Schulalter, gelten dieselben Sofortmaßnahmen wie bei Erwachsenen, inklusive 60-Minuten-Fenster.',
          },
          {
            q: 'Zahlt meine Reiseversicherung die Behandlung?',
            a: 'Auslandskrankenversicherungen übernehmen zahnärztliche Notfallbehandlungen in der Regel ganz oder teilweise. Sie erhalten von uns eine detaillierte Rechnung und alle Unterlagen für die Erstattung. Was Urlauber sonst noch wissen sollten, steht in unserem Guide zum Zahnnotfall im Urlaub.',
          },
          {
            q: 'Hält der Composite-Aufbau dauerhaft?',
            a: 'Ja — bei guter Mundhygiene und regelmäßiger Prophylaxe halten direkte Composite-Aufbauten viele Jahre, oft bis zu 20. Und falls doch einmal eine Ecke abplatzt, reparieren wir die Stelle punktuell, ohne den gesamten Aufbau zu erneuern.',
          },
        ],
      },
      finalCta: {
        title: 'Zahn abgebrochen? Warten macht es nicht besser.',
        body: 'Rufen Sie jetzt an oder schicken Sie uns ein Foto per WhatsApp — wir sagen Ihnen sofort, wie es weitergeht, und behandeln Sie in den meisten Fällen noch am selben Tag. Zentral in Palma, an der Avenida de Jaime III.',
      },
    },

    // === Spoke: Akute Zahnschmerzen (§4.3) ===
    toothache: {
      breadcrumb: 'Akute Zahnschmerzen',
      h1: 'Akute Zahnschmerzen auf Mallorca? Wir nehmen Ihren Schmerz ernst — Sofort-Termin in Palma',
      heroIntro: 'Zahnschmerzen können einen ganzen Tag — und eine ganze Nacht — unerträglich machen. Atmen Sie durch: Hinter fast jedem Zahnschmerz steckt eine Ursache, die sich behandeln lässt, meist noch am selben Tag. Rufen Sie an, wir melden uns in unter 30 Minuten zurück.',
      heroNote: 'Unser Notfall-Telefon erreichen Sie rund um die Uhr — auch per WhatsApp. Schildern Sie kurz Ihre Beschwerden, wir sagen Ihnen sofort, wie es weitergeht.',
      sections: [
        {
          icon: 'emergency',
          title: 'Wann sind Zahnschmerzen ein Notfall?',
          intro: 'Nicht jedes Ziehen braucht einen Notfalltermin — aber bei diesen Warnzeichen sollten Sie nicht warten, sondern sofort anrufen:',
          items: [
            {
              title: 'Pochender, klopfender Schmerz',
              body: 'Ein pulsierender Schmerz im Takt des Herzschlags spricht für eine Entzündung des Zahnnervs. Sie klingt nicht von selbst ab — je früher wir behandeln, desto größer die Chance, den Zahn zu erhalten.',
            },
            {
              title: 'Schmerzen, die Sie nicht schlafen lassen',
              body: 'Wenn der Schmerz Sie nachts wachhält, ist der Zahnnerv meist bereits stark gereizt. Jeder weitere Tag Warten verschlimmert die Lage — melden Sie sich noch heute.',
            },
            {
              title: 'Schwellung oder Fieber',
              body: 'Eine geschwollene Wange, ein Spannungsgefühl im Kiefer oder Fieber deuten auf einen Abszess hin — eine Eiteransammlung, die zügig behandelt werden muss. Was dann zu tun ist, lesen Sie auf unserer Seite zum Zahnabszess.',
            },
            {
              title: 'Schmerz, der plötzlich verschwindet',
              body: 'Klingt paradox, ist aber ein Alarmsignal: Hört starker Zahnschmerz schlagartig auf, kann der Nerv abgestorben sein. Die Entzündung arbeitet still weiter — lassen Sie den Zahn unbedingt kontrollieren.',
            },
          ],
        },
        {
          icon: 'bedtime',
          title: 'Zahnschmerzen nachts: warum es im Liegen schlimmer wird',
          intro: 'Viele Patienten berichten, dass der Schmerz abends und nachts am schlimmsten ist. Das hat einen einfachen Grund: Im Liegen steigt der Blutdruck im Kopf, das entzündete Gewebe im Zahninneren schwillt weiter an — und der Druck auf den Nerv wächst. Dazu fehlt nachts die Ablenkung des Tages, und der Schmerz rückt ins Zentrum.',
          items: [
            {
              title: 'Was bis zum Termin überbrückt',
              body: 'Lagern Sie den Kopf beim Liegen erhöht — ein zweites Kissen genügt oft schon. Kühlen Sie die Wange von außen mit einer kalten Kompresse; Wärme dagegen verstärkt die Entzündung. Verzichten Sie auf Alkohol, Nikotin und sehr heiße oder sehr kalte Getränke. Hausmittel wie lauwarme Salzwasserspülungen können kurz Linderung bringen — sie sind eine ehrliche Überbrückung, aber kein Ersatz für die Behandlung: Der Schmerz kommt zurück, solange die Ursache bleibt.',
            },
            {
              title: 'Schmerzmittel: was Sie wissen sollten',
              body: 'Rezeptfreie Schmerzmittel können kurzfristig überbrücken — beachten Sie die Packungsbeilage bzw. fragen Sie in der Apotheke, und sagen Sie uns vor der Behandlung, was Sie eingenommen haben. Wichtig: Präparate mit Acetylsalicylsäure können die Blutungsneigung erhöhen.',
            },
          ],
        },
        {
          icon: 'search',
          title: 'Häufige Ursachen für akute Zahnschmerzen',
          intro: 'Zahnschmerz ist ein Symptom — die Ursache finden wir mit moderner Diagnostik. Die häufigsten Auslöser:',
          items: [
            {
              title: 'Pulpitis: Entzündung des Zahnnervs',
              body: 'Die häufigste Ursache für heftigen, pochenden Zahnschmerz. Bakterien reizen das Nervengewebe im Zahninneren, es entzündet sich und schwillt an — und weil im Zahn kein Platz zum Ausweichen ist, entsteht enormer Druck. Im frühen Stadium ist die Entzündung oft noch umkehrbar; unbehandelt stirbt der Nerv ab, und aus der Entzündung kann ein Abszess werden. Deshalb lohnt es sich, früh zu kommen.',
            },
            {
              title: 'Tiefe Karies',
              body: 'Karies schmerzt lange gar nicht — bis sie in die Nähe des Nervs vordringt. Dann reagiert der Zahn empfindlich auf Süßes, Kaltes oder Warmes. Wer jetzt handelt, kann den Nerv oft noch retten.',
            },
            {
              title: 'Riss im Zahn',
              body: 'Ein feiner Sprung — etwa nach dem Biss auf einen Olivenkern — verursacht typischerweise einen kurzen, stechenden Schmerz beim Kauen. Solche Risse sind auf herkömmlichen Röntgenbildern oft unsichtbar; unter dem Dentalmikroskop finden wir sie.',
            },
            {
              title: 'Abszess',
              body: 'Gesellen sich zum Schmerz eine Schwellung, ein Druckgefühl oder Fieber, hat sich vermutlich Eiter gebildet. Ein Abszess ist immer ein Fall für den Zahnarzt — alles Wichtige dazu auf unserer Abszess-Seite.',
            },
          ],
        },
      ],
      solve: {
        title: 'So lösen wir das bei SeaDent: Ursache finden, Schmerz stoppen, Zahn erhalten',
        intro: 'Ihr Zahn ist bei uns kein Fall für die Zange — wir versuchen immer zuerst zu erhalten. Ein schnell gezogener Zahn wirkt wie die einfache Lösung, zieht aber Folgekosten und Folgebehandlungen nach sich. Deshalb setzen wir auf Diagnostik und Technik, die weit über die übliche Notfallversorgung hinausgeht:',
        points: [
          {
            title: 'Digitales 3D-Röntgen (DVT) für die exakte Diagnose',
            body: 'Bevor wir behandeln, sehen wir genau hin: Unser digitales 3D-Röntgen zeigt Entzündungsherde, Wurzelkanäle und versteckte Ursachen räumlich — strahlungsarm und in wenigen Minuten. So behandeln wir die Ursache, nicht nur das Symptom.',
          },
          {
            title: 'Notfall-Wurzelbehandlung unter dem Dentalmikroskop',
            body: 'Ist der Nerv entzündet, entfernen wir das erkrankte Gewebe unter starker Vergrößerung. Das Mikroskop macht selbst feinste Kanäle sichtbar — das erhöht die Erfolgsrate deutlich und ist der Grund, warum wir Zähne erhalten können, die anderswo gezogen würden. Der Schmerz stoppt in der Regel noch in derselben Sitzung.',
          },
          {
            title: 'Dentallaser zur Keimreduktion',
            body: 'Mit dem Dentallaser sterilisieren wir die Wurzelkanäle nahezu vollständig — schonend, präzise und ohne das umliegende Gewebe zu belasten. Das senkt das Risiko, dass die Entzündung zurückkommt.',
          },
        ],
        links: [
          { text: 'Dentalmikroskop, Laser & 3D-Röntgen: unsere Technologien im Detail', routeKey: 'technologies' },
        ],
      },
      faq: {
        title: 'Häufige Fragen bei akuten Zahnschmerzen',
        items: [
          {
            q: 'Bekomme ich heute noch einen Termin?',
            a: 'In den allermeisten Fällen ja. Rufen Sie an oder schreiben Sie per WhatsApp — wir melden uns in unter 30 Minuten zurück und halten in unserem Tagesplan Kapazität für Notfälle frei.',
          },
          {
            q: 'Was kostet die Notfallbehandlung?',
            a: 'Das hängt von der Ursache ab — eine Untersuchung mit Röntgenbild ist etwas anderes als eine Wurzelbehandlung. Sie erhalten vor jeder Behandlung einen schriftlichen Kostenvoranschlag und können bequem mit Karte zahlen.',
          },
          {
            q: 'Helfen Hausmittel wirklich?',
            a: 'Ehrliche Antwort: nur kurz. Kühlen, Salzwasserspülungen und erhöhtes Liegen lindern die Symptome — die Ursache im Zahninneren erreichen sie nicht. Deshalb kommt der Schmerz zurück, oft stärker. Nutzen Sie Hausmittel als Überbrückung bis zum Termin, nicht als Ersatz dafür.',
          },
          {
            q: 'Was, wenn es am Wochenende passiert?',
            a: 'Unser Notfall-Telefon ist rund um die Uhr erreichbar — an jedem Tag der Woche. Termine vereinbaren wir dann nach telefonischer Absprache. Alle Details dazu finden Sie auf unserer Notdienst-Übersicht.',
          },
          {
            q: 'Muss der Zahn gezogen werden?',
            a: 'Meist nicht. Dank Wurzelbehandlung unter dem Mikroskop und Dentallaser können wir viele Zähne erhalten, die früher gezogen worden wären. Ziehen ist bei uns die letzte Option — nicht die erste.',
          },
        ],
      },
      finalCta: {
        title: 'Ihr Schmerz hat eine Ursache — und wir finden sie.',
        body: 'Warten Sie nicht, bis es unerträglich wird. Rufen Sie jetzt an: Wir hören zu, melden uns in unter 30 Minuten zurück und stoppen den Schmerz in den meisten Fällen noch am selben Tag — zentral in Palma, an der Avenida de Jaime III.',
      },
    },

    // === Spoke: Zahnnotfall im Urlaub (§4.4) ===
    tourists: {
      breadcrumb: 'Zahnnotfall im Urlaub',
      h1: 'Zahnnotfall im Urlaub auf Mallorca — Ihr Fahrplan, Schritt für Schritt',
      heroIntro: 'Ein Zahnnotfall mitten im Urlaub — ausgerechnet jetzt. Atmen Sie durch: Sie sind hier richtig. Wir behandeln Urlauber jeden Tag, sprechen Ihre Sprache und kümmern uns darum, dass Ihr Urlaub weitergehen kann. Auf dieser Seite finden Sie alles, was Sie jetzt wissen müssen: erste Schritte, Kosten, Versicherung und der schnellste Weg zu uns.',
      heroNote: 'Wir sprechen Deutsch, Englisch und Spanisch — schreiben Sie uns einfach per WhatsApp, gern mit Foto.',
      sections: [
        {
          icon: 'beach_access',
          title: 'Die 4 häufigsten Urlaubs-Notfälle — und der schnellste Weg zur Lösung',
          intro: 'Vier Situationen machen den Großteil aller Notfälle bei Urlaubern aus. Für jede gibt es einen klaren Fahrplan:',
          items: [
            {
              title: 'Akute Zahnschmerzen',
              body: 'Der Klassiker: Der Zahn meldet sich ausgerechnet in der Ferienwoche. Rufen Sie an, bevor Sie auf eigene Faust experimentieren — wir finden die Ursache und stoppen den Schmerz meist am selben Tag. Alle Details auf unserer Seite zu akuten Zahnschmerzen.',
            },
            {
              title: 'Zahn abgebrochen',
              body: 'Sturz am Pool, Biss auf einen Olivenkern: Bewahren Sie das Bruchstück in Milch auf und melden Sie sich sofort. Was genau zu tun ist, steht Schritt für Schritt auf unserer Seite „Zahn abgebrochen".',
            },
            {
              title: 'Füllung oder Krone verloren',
              body: 'Nicht dramatisch, aber unangenehm: Der Zahn liegt frei und reagiert empfindlich. Krone aufbewahren, nichts selbst festkleben, auf der anderen Seite kauen — und zeitnah zu uns kommen.',
            },
            {
              title: 'Dicke Backe / Abszess',
              body: 'Eine geschwollene Wange gehört nicht zum Urlaub dazu: Sie ist ein Warnsignal, das schnell behandelt werden muss. Warum Abwarten hier riskant ist, erklärt unsere Abszess-Seite.',
            },
          ],
        },
        {
          icon: 'payments',
          title: 'Kosten & Versicherung: was Urlauber wissen müssen',
          intro: 'Die häufigste Sorge im Zahnnotfall ist nicht der Bohrer — es ist die Rechnung. Hier die ehrlichen Antworten, damit Sie ohne böse Überraschung in die Behandlung gehen:',
          items: [
            {
              title: 'EHIC: was die Europäische Krankenversicherungskarte kann — und was nicht',
              body: 'Mit der EHIC (in Deutschland auf der Rückseite der Gesundheitskarte) haben gesetzlich Versicherte Anspruch auf medizinisch notwendige Behandlungen im öffentlichen spanischen Gesundheitssystem. Wichtig zu wissen: Zahnbehandlungen sind dort kaum abgedeckt, und in Privatkliniken — dazu zählen praktisch alle Zahnarztpraxen auf Mallorca — gilt die EHIC nicht. Die Behandlung zahlen Sie also zunächst selbst.',
            },
            {
              title: 'Auslandskrankenversicherung: Ihr wichtigster Schutz',
              body: 'Eine private Auslandsreisekrankenversicherung übernimmt zahnärztliche Notfall- und Schmerzbehandlungen in der Regel ganz oder bis zu einer vereinbarten Grenze. Prüfen Sie Ihre Police oder rufen Sie die Hotline Ihrer Versicherung an — meist genügt es, dass die Behandlung medizinisch notwendig und als Notfall dokumentiert ist. Genau diese Dokumentation bekommen Sie von uns.',
            },
            {
              title: 'Volle Transparenz vor der Behandlung',
              body: 'Bei uns gibt es keine Überraschungen: Sie erhalten vor jeder Behandlung einen schriftlichen Kostenvoranschlag und entscheiden selbst, was gemacht wird. Bezahlen können Sie bequem mit Karte.',
            },
            {
              title: 'Alle Unterlagen für die Erstattung',
              body: 'Nach der Behandlung erhalten Sie eine detaillierte Rechnung, auf Wunsch einen mehrsprachigen Befundbericht und Ihre Röntgenbilder — alles, was Ihre Versicherung für die Erstattung braucht und Ihr Hauszahnarzt für die Weiterbehandlung.',
            },
          ],
        },
        {
          icon: 'directions_bus',
          title: 'So finden Sie uns vom Hotel aus',
          intro: 'Unsere Praxis liegt mitten im Zentrum von Palma: Avenida de Jaime III, 3 — an einer der bekanntesten Einkaufsstraßen der Stadt. Jeder Taxifahrer kennt die Adresse, und in Google Maps genügt die Suche nach „SeaDent Mallorca".',
          items: [
            {
              title: 'Von der Playa de Palma und s\'Arenal',
              body: 'Mit dem Taxi sind Sie in etwa 15 bis 20 Minuten direkt vor der Tür. Alternativ bringen Sie die Stadtbusse Richtung Zentrum bis in den Bereich Jaume III / Passeig de Mallorca — von dort sind es nur wenige Schritte.',
            },
            {
              title: 'Von Alcúdia und dem Norden',
              body: 'Mit dem Auto über die Ma-13 erreichen Sie Palma in rund 45 bis 50 Minuten. Es gibt auch direkte Busverbindungen zum Busbahnhof Estació Intermodal; von dort sind es etwa 15 Minuten zu Fuß zur Praxis.',
            },
            {
              title: 'Von Port d\'Andratx und dem Südwesten',
              body: 'Über die Ma-1 sind Sie mit Auto oder Taxi in etwa 30 Minuten bei uns — die Ausfahrt ins Zentrum führt fast direkt auf die Avenida de Jaime III zu.',
            },
            {
              title: 'Parken',
              body: 'Am bequemsten in den Parkhäusern Vía Roma oder El Corte Inglés — beide liegen nur wenige Gehminuten von der Praxis entfernt.',
            },
          ],
        },
        {
          icon: 'medical_services',
          title: 'Implantat-Probleme im Urlaub — auch bei Fremdimplantaten',
          intro: 'Die Krone auf dem Implantat hat sich gelöst, das Zahnfleisch am Implantat ist entzündet, es schmerzt beim Kauen? Kommen Sie zu uns — auch wenn Ihr Implantat woanders gesetzt wurde, etwa in der Türkei oder in Ungarn.',
          items: [
            {
              title: 'Diagnose ohne Unterlagen der Original-Klinik',
              body: 'Mit digitalem 3D-Röntgen und computergestützter Diagnostik verschaffen wir uns ein genaues Bild von Implantat, Knochen und Zahnfleisch — auch dann, wenn Sie keine Unterlagen der behandelnden Klinik dabeihaben.',
            },
            {
              title: 'Behandlung, die das Implantat schützt',
              body: 'Gelöste Kronen und Aufbauten befestigen wir neu, Entzündungen am Implantat behandeln wir gezielt, bevor der Knochen Schaden nimmt. So überstehen Implantat und Urlaub die Sache gleichermaßen gut.',
            },
          ],
        },
      ],
      solve: {
        title: 'So lösen wir das bei SeaDent: Ihr Urlaub geht weiter',
        intro: 'Unser Anspruch bei Urlaubern: eine Lösung, die den Rest der Reise trägt — nicht eine Übergangslösung, die zu Hause sofort erneuert werden muss.',
        points: [
          {
            title: 'Fertig in einer Sitzung statt Provisorium-Odyssee',
            body: 'Einen abgebrochenen Zahn bauen wir mit Composite in einer einzigen Sitzung wieder auf — ohne Labor, ohne zweiten Termin, ohne Provisorium, das am Buffet gleich wieder abfällt. Sie verlieren einen halben Urlaubstag, nicht die halbe Reise — und das Ergebnis hält weit über den Urlaub hinaus.',
          },
          {
            title: 'Behandlung, die Ihre Reisepläne berücksichtigt',
            body: 'Wir fragen, was Sie noch vorhaben — Rückflug, Bootsausflug, Wanderung — und planen die Behandlung so, dass Sie Ihren Urlaub fortsetzen können. Und wir sagen Ihnen ehrlich, was jetzt nötig ist und was bis zu Ihrem Hauszahnarzt warten kann.',
          },
          {
            title: 'Mehrsprachiger Befundbericht für Ihren Hauszahnarzt',
            body: 'Auf Wunsch erhalten Sie einen Befundbericht in Ihrer Sprache samt Röntgenbildern — so kann Ihr Zahnarzt zu Hause nahtlos übernehmen, und Ihre Versicherung bekommt alle nötigen Unterlagen gleich mit.',
          },
        ],
        links: [
          { text: 'Composite-Aufbau in einer Sitzung', routeKey: 'composite' },
          { text: 'Implantate bei SeaDent — Diagnostik & Versorgung', routeKey: 'implants' },
        ],
      },
      faq: {
        title: 'Häufige Fragen von Urlaubern',
        items: [
          {
            q: 'Akzeptieren Sie die EHIC (Europäische Krankenversicherungskarte)?',
            a: 'Die EHIC gilt im öffentlichen spanischen Gesundheitssystem — zahnärztliche Behandlungen in Privatkliniken wie unserer deckt sie nicht ab. Sie zahlen zunächst selbst und reichen die Rechnung bei Ihrer Auslandskrankenversicherung ein; die nötigen Unterlagen stellen wir Ihnen vollständig aus.',
          },
          {
            q: 'Kann ich mit Karte zahlen?',
            a: 'Ja, selbstverständlich. Vor der Behandlung erhalten Sie einen schriftlichen Kostenvoranschlag, danach eine detaillierte Rechnung für Ihre Versicherung.',
          },
          {
            q: 'Bin ich nach der Behandlung flugfähig?',
            a: 'Nach den meisten Behandlungen können Sie problemlos fliegen. Nach einer frischen Wurzelbehandlung oder Abszess-Behandlung besprechen wir das individuell — der Druckwechsel in der Kabine kann in Einzelfällen eine Rolle spielen. Nennen Sie uns einfach Ihr Abreisedatum, wir planen die Behandlung danach.',
          },
          {
            q: 'Bekomme ich ein Attest oder Unterlagen für meine Versicherung?',
            a: 'Ja: eine detaillierte Rechnung, die Behandlungsdokumentation und auf Wunsch einen mehrsprachigen Befundbericht samt Röntgenbildern — für die Erstattung ebenso wie für Ihren Hauszahnarzt.',
          },
          {
            q: 'Geht ein Termin noch am Abreisetag?',
            a: 'Oft ja — rufen Sie so früh wie möglich an und nennen Sie uns Ihre Abflugzeit. Für echte Notfälle halten wir Kapazität frei; ein Composite-Aufbau oder eine Schmerzbehandlung ist häufig in ein bis zwei Stunden abgeschlossen. Rechnung und Unterlagen für die Versicherung bekommen Sie direkt mit — Sie müssen nach dem Urlaub nichts nachfordern.',
          },
          {
            q: 'Muss ich vorher einen Termin vereinbaren?',
            a: 'Rufen Sie bitte immer zuerst an oder schreiben Sie per WhatsApp. So können wir Ihre Ankunft vorbereiten, und Sie warten nicht unnötig — wir melden uns in unter 30 Minuten zurück.',
          },
        ],
      },
      finalCta: {
        title: 'Ihr Urlaub ist zu kostbar für Zahnschmerzen.',
        body: 'Rufen Sie an oder schreiben Sie per WhatsApp — auf Deutsch, Englisch oder Spanisch. Wir melden uns in unter 30 Minuten zurück und kümmern uns um den Zahn, damit Sie sich wieder um Ihren Urlaub kümmern können.',
      },
    },

    // === Spoke: Zahnabszess / dicke Backe (§4.5) ===
    abscess: {
      breadcrumb: 'Zahnabszess',
      h1: 'Zahnabszess oder geschwollene Wange? Handeln Sie heute — wir sind erreichbar',
      heroIntro: 'Eine dicke Backe ist beunruhigend — und Ihr Körper meint es ernst damit. Die gute Nachricht: Ein Abszess lässt sich gut behandeln, und die Erleichterung setzt meist unmittelbar nach dem Eingriff ein. Wichtig ist nur eines: heute handeln, nicht morgen.',
      warnbox: {
        title: 'Wann Sie zuerst den Notruf wählen',
        body: 'Bei Fieber, Schluckbeschwerden, Atemnot oder einer Schwellung Richtung Auge oder Hals: Rufen Sie sofort den Notruf 112 (bzw. 061 auf den Balearen) — danach uns.',
      },
      sections: [
        {
          icon: 'search',
          title: 'Symptome erkennen: Abszess oder harmlose Reizung?',
          intro: 'Nicht jede Schwellung ist ein Abszess — aber jede Schwellung gehört abgeklärt. So ordnen Sie die Zeichen ein:',
          items: [
            {
              title: 'Zahnabszess: Eiterherd an der Zahnwurzel',
              body: 'Typisch sind anhaltender, pochender Schmerz, ein Zahn, der sich beim Zubeißen „zu hoch" anfühlt und auf Klopfen reagiert, eine Schwellung von Zahnfleisch oder Wange, ein schlechter Geschmack im Mund — manchmal auch Fieber und Abgeschlagenheit. Ursache ist meist ein tief kariöser oder abgestorbener Zahn.',
            },
            {
              title: 'Zahnfleischabszess: Eiterherd in der Zahnfleischtasche',
              body: 'Hier sitzt die Schwellung direkt am Zahnfleischrand: eine glänzende, pralle, druckempfindliche Beule — oft ausgelöst durch einen eingedrückten Essensrest oder eine fortgeschrittene Zahnfleischentzündung. Der Zahn selbst kann dabei völlig gesund sein.',
            },
            {
              title: 'Zahnfleischbluten: Warnsignal, aber selten ein Akutfall',
              body: 'Blutet das Zahnfleisch beim Putzen, steckt meist eine Zahnfleischentzündung dahinter — unangenehm, aber kein Notfall. Kommen jedoch Schwellung, Eiter oder pochender Schmerz hinzu, ist die Grenze zum Abszess erreicht: Dann rufen Sie uns noch heute an.',
            },
            {
              title: 'Harmlose Reizung',
              body: 'Eine leichte Rötung nach zu kräftigem Putzen oder eine Druckstelle durch eine Prothese verschwindet in der Regel binnen weniger Tage von selbst. Bleibt die Stelle länger bestehen, wächst sie oder beginnt zu pochen — abklären lassen.',
            },
          ],
        },
        {
          icon: 'hourglass_top',
          title: 'Warum Abwarten und Hausmittel gefährlich sind',
          intro: 'Wir sagen es sachlich, weil es schlicht stimmt: Ein Abszess geht nicht von selbst weg. Der Eiterherd ist abgekapselt — keine Spülung und kein Hausmittel erreicht ihn.',
          items: [
            {
              title: 'Die Infektion sucht sich ihren Weg',
              body: 'Der Eiter sitzt in einem geschlossenen Raum und steht unter Druck. Ohne Behandlung breitet sich die Infektion entlang der Gewebeschichten aus — im Oberkiefer Richtung Auge und Nebenhöhlen, im Unterkiefer Richtung Mundboden und Hals. Genau deshalb gelten Fieber, Schluckbeschwerden und Atemnot als Notruf-Kriterien.',
            },
            {
              title: 'Nachlassender Schmerz ist keine Entwarnung',
              body: 'Manchmal entlastet sich ein Abszess kurzzeitig von selbst, oder der Zahnnerv stirbt ab — der Schmerz wird schwächer, die Infektion bleibt und arbeitet weiter. Die Ursache kann nur zahnärztlich behandelt werden; je früher, desto einfacher der Eingriff.',
            },
          ],
        },
        {
          icon: 'ac_unit',
          title: 'Was Sie bis zum Termin tun können',
          intro: 'Bis Sie bei uns sind, helfen drei einfache Regeln:',
          items: [
            {
              title: 'Kühlen — von außen, in Intervallen',
              body: 'Eine kalte Kompresse, in ein Tuch gewickelt, lindert den Schmerz und bremst die Schwellung. Legen Sie immer wieder Pausen ein und bringen Sie Eis nie direkt auf die Haut.',
            },
            {
              title: 'Auf keinen Fall wärmen',
              body: 'Wärmflasche, Rotlicht oder heiße Auflagen fördern die Durchblutung — und damit die Ausbreitung der Infektion. Meiden Sie auch pralle Sonne und Sauna.',
            },
            {
              title: 'Nicht aufstechen, nicht drücken',
              body: 'So verlockend es sein mag: Öffnen Sie den Abszess niemals selbst. Ohne sterile Bedingungen drücken Sie Keime tiefer ins Gewebe und verschlimmern die Infektion. Die Entlastung gehört in zahnärztliche Hände.',
            },
          ],
        },
      ],
      solve: {
        title: 'So lösen wir das bei SeaDent: Druck raus, Ursache behandeln',
        intro: 'Ein Abszess braucht zwei Dinge: sofortige Entlastung und die Behandlung der Ursache. Beides bekommen Sie bei uns aus einer Hand — mit einer Ausstattung, die weit über die klassische Notfallversorgung hinausgeht.',
        points: [
          {
            title: 'Drainage: spürbare Erleichterung',
            body: 'Wir öffnen den Abszess unter örtlicher Betäubung kontrolliert und lassen den Eiter abfließen. Der Druckschmerz lässt fast unmittelbar nach — die meisten Patienten beschreiben es als sofortige Befreiung.',
          },
          {
            title: 'Dentallaser für Keimreduktion und Blutstillung',
            body: 'Der Dentallaser desinfiziert das entzündete Gewebe, reduziert die Keimzahl deutlich und stillt Blutungen — schonend und ohne das umliegende Gewebe zusätzlich zu belasten. Das beschleunigt die Heilung spürbar.',
          },
          {
            title: 'Ursachenbehandlung: Wurzelbehandlung unter dem Mikroskop',
            body: 'Damit der Abszess nicht wiederkommt, behandeln wir die Quelle — meist einen entzündeten oder abgestorbenen Zahnnerv. Unter dem Dentalmikroskop reinigen wir die Wurzelkanäle mit höchster Präzision; so lässt sich der Zahn in vielen Fällen dauerhaft erhalten.',
          },
          {
            title: 'Antibiotika: wenn nötig — entschieden nach Befund',
            body: 'Ob ein Antibiotikum sinnvoll ist, entscheidet der Zahnarzt nach der Untersuchung — abhängig von Ausdehnung, Fieber und Ihrem Allgemeinzustand. Wichtig zu wissen: Ein Antibiotikum allein löst das Problem nicht, denn den abgekapselten Eiterherd erreicht es kaum. Ohne Entlastung und Ursachenbehandlung kommt der Abszess zurück.',
          },
        ],
        links: [
          { text: 'Dentallaser & Mikroskop: unsere Technologien', routeKey: 'technologies' },
          { text: 'Akute Zahnschmerzen — wann sie zum Notfall werden', routeKey: 'emergency-toothache' },
        ],
      },
      faq: {
        title: 'Häufige Fragen zum Zahnabszess',
        items: [
          {
            q: 'Geht ein Abszess von allein weg?',
            a: 'Nein. Selbst wenn Schwellung oder Schmerz zeitweise nachlassen, bleibt der Infektionsherd bestehen und meldet sich zurück — oft stärker als zuvor. Ein Abszess muss entlastet und seine Ursache behandelt werden.',
          },
          {
            q: 'Bekomme ich Antibiotika auch ohne Termin?',
            a: 'Nein — und das aus gutem Grund: Ohne Untersuchung lässt sich nicht beurteilen, ob ein Antibiotikum überhaupt nötig ist. Vor allem aber löst es das Problem allein nicht, weil es den abgekapselten Eiterherd kaum erreicht. Die Untersuchung geht schnell — und danach wissen Sie sicher, woran Sie sind.',
          },
          {
            q: 'Was kostet die Behandlung?',
            a: 'Das hängt vom Befund ab — von der reinen Entlastung bis zur Wurzelbehandlung. Sie erhalten vor der Behandlung einen schriftlichen Kostenvoranschlag und im Anschluss alle Unterlagen für Ihre Versicherung.',
          },
          {
            q: 'Kann ich mit einem Abszess fliegen?',
            a: 'Davon raten wir ab, solange der Abszess unbehandelt ist: Der Druckwechsel in der Kabine kann die Schmerzen deutlich verstärken, und eine sich ausbreitende Infektion gehört nicht in die Luft. Lassen Sie den Abszess vor dem Abflug behandeln — nennen Sie uns Ihr Reisedatum, wir richten uns danach.',
          },
        ],
      },
      finalCta: {
        title: 'Eine dicke Backe wartet nicht — wir auch nicht.',
        body: 'Rufen Sie jetzt an: Wir melden uns in unter 30 Minuten zurück und entlasten den Abszess in den meisten Fällen noch am selben Tag. Zentral in Palma, an der Avenida de Jaime III.',
      },
    },
  }
};